/* Unpublished-theme backup for storefront search and collection grids.
   Search enters the engine page first. Native results cover zero or outage. */
(function () {
  'use strict';

  var TRANSPORT = {
    sfs_filters: 1,
    sfs_cards: 1,
    sfs_fragment: 1,
    sfs_endpoint: 1,
    sfs_browse: 1,
    sfs_page_size: 1,
    sfs_collection: 1,
    sfs_group: 1,
    sfs_query: 1
  };
  var PREVIEW_KEYS = { preview_theme_id: 1, _fd: 1, pb: 1 };
  var TRACKING_KEYS = {
    gclid: 1, gbraid: 1, wbraid: 1, gad_source: 1, gad_campaignid: 1, dclid: 1,
    fbclid: 1, msclkid: 1, ttclid: 1, twclid: 1, li_fat_id: 1, srsltid: 1,
    mc_cid: 1, mc_eid: 1, _kx: 1, _ke: 1, klaviyo_id: 1, oseid: 1,
    ref: 1, _pos: 1, _sid: 1, _ss: 1, _psq: 1, _fid: 1
  };
  var SHOPIFY_SORTS = {
    relevance: 1,
    'best-selling': 1,
    'title-ascending': 1,
    'title-descending': 1,
    'price-ascending': 1,
    'price-descending': 1,
    'created-ascending': 1,
    'created-descending': 1,
    manual: 1
  };
  var COOLDOWN_REASONS = { timeout: 1, http_error: 1, network: 1, invalid_payload: 1 };
  var COOL_KEY = 'sfs_native_fallback_cooldown_v1';
  var PAGE_COOL_KEY = 'sfs_native_fallback_page_cooldown_v1';
  var DIAG_KEY = 'sfs_native_fallback_diag_v1';
  var SOURCE_PREFIX = 'sfs_result_source_v1:';
  var UNSUPPORTED_COPY = 'This filter cannot be applied to backup results. Choose a different filter or clear it.';
  var NATIVE_FAIL_COPY = 'Results could not be loaded. Try again or browse products.';
  var CLEAR_LABEL = 'Show results without this filter';
  var generations = { search: 0, collection: 0, dropdown: 0 };
  var memory = {};
  var diagnostics = [];
  var baseline = null;
  var guardInstalled = false;
  var searchAbort = null;
  var restoreFilterRow = null;
  var leavingPage = false;
  var nativeSectionId = '';
  var nativeFacetNames = [];
  var nativeSortValues = [];
  var renderedSearchUrl = '';
  var renderedSearchState = null;
  var documentSource = null;
  var availabilityOn = false;
  var availabilityObserver = null;
  var availabilityQueued = false;
  var nowFn = function () { return Date.now(); };

  function now() { return nowFn(); }

  function enabled() {
    var cfg = typeof window !== 'undefined' && window.SFS_NATIVE_FALLBACK;
    return !!(cfg && cfg.enabled === true);
  }

  function timeoutMs() {
    var cfg = typeof window !== 'undefined' && window.SFS_NATIVE_FALLBACK;
    var value = cfg && parseInt(cfg.timeoutMs, 10);
    return value > 0 ? value : 2500;
  }

  function cooldownMs() {
    var cfg = typeof window !== 'undefined' && window.SFS_NATIVE_FALLBACK;
    var value = cfg && parseInt(cfg.cooldownMs, 10);
    return value > 0 ? value : 15000;
  }

  function storageGet(key) {
    try {
      if (typeof sessionStorage !== 'undefined') {
        var raw = sessionStorage.getItem(key);
        if (raw != null) return raw;
      }
    } catch (e) {}
    return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null;
  }

  function storageSet(key, value) {
    memory[key] = value;
    try {
      if (typeof sessionStorage !== 'undefined') sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function storageRemove(key) {
    delete memory[key];
    try {
      if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(key);
    } catch (e) {}
  }

  function normQuery(value) {
    return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  function pageNumber(raw) {
    var value = parseInt(String(raw || '1'), 10);
    if (!isFinite(value) || value < 1) return 1;
    return value;
  }

  function originBase() {
    if (typeof window !== 'undefined' && window.location && window.location.href) return window.location.href;
    return 'https://example.com/';
  }

  function isTrackingKey(key) {
    return key.indexOf('utm_') === 0 || Object.prototype.hasOwnProperty.call(TRACKING_KEYS, key);
  }

  function copyTracking(target, source) {
    var missing = Array.from(new Set(Array.from(source.searchParams.keys()))).filter(function (key) {
      return isTrackingKey(key) && !target.searchParams.has(key);
    });
    missing.forEach(function (key) {
      source.searchParams.getAll(key).forEach(function (value) { target.searchParams.append(key, value); });
    });
  }

  function copyPreview(target, source) {
    var current = new URL(originBase());
    if (source) copyTracking(target, source);
    copyTracking(target, current);
    Object.keys(PREVIEW_KEYS).forEach(function (key) {
      var values = current.searchParams.getAll(key);
      target.searchParams.delete(key);
      if (values.length === 1 && values[0]) target.searchParams.set(key, values[0]);
    });
  }

  // Read only a flat object of known string options, retaining duplicate evidence.
  function aggregateOptions(raw) {
    if (raw.length > 300) return null;
    var rest = raw.trim();
    if (rest.charAt(0) !== '{' || rest.charAt(rest.length - 1) !== '}') return null;
    rest = rest.slice(1, -1).trim();
    if (!rest) return null;
    var result = {};
    var separator = '';
    while (rest) {
      var pair = /^"(prefix|unavailable_products)"\s*(:|=>)\s*"(last|none|hide|show)"\s*/.exec(rest);
      if (!pair || (separator && separator !== pair[2])) return null;
      var key = pair[1], value = pair[3];
      if (Object.prototype.hasOwnProperty.call(result, key) ||
          (key === 'prefix' && !/^(last|none)$/.test(value)) ||
          (key === 'unavailable_products' && !/^(last|hide|show)$/.test(value))) return null;
      separator = pair[2];
      result[key] = value;
      rest = rest.slice(pair[0].length);
      if (!rest) return result;
      if (rest.charAt(0) !== ',') return null;
      rest = rest.slice(1).trim();
      if (!rest) return null;
    }
    return null;
  }

  function readState(href) {
    var url = new URL(href, originBase());
    var queries = url.searchParams.getAll('q');
    var q = queries.length === 1 ? queries[0].trim() : '';
    var parts = url.pathname.split('/').filter(Boolean);
    var collection = parts[0] === 'collections' && parts[1] ? decodeURIComponent(parts[1]) : '';
    var sortBy = url.searchParams.get('sort_by') || '';
    var engineSort = url.searchParams.get('sort') || '';
    var poles = [];
    var hard = [];
    var engineFilters = [];
    if (queries.length > 1) queries.forEach(function (value) { hard.push('q=' + value); });
    url.searchParams.getAll('sfs_poles').forEach(function (value) {
      if (/^[1-4] Pole$/.test(value)) {
        if (poles.indexOf(value) === -1) poles.push(value);
      } else hard.push('sfs_poles=' + value);
    });
    url.searchParams.getAll('filter.p.m.breakers.poles').forEach(function (value) {
      if (/^[1-4]$/.test(value)) {
        var label = value + ' Pole';
        if (poles.indexOf(label) === -1) poles.push(label);
      } else hard.push('filter.p.m.breakers.poles=' + value);
    });
    var availability = url.searchParams.getAll('filter.v.availability').filter(Boolean);
    var extra = [];
    url.searchParams.forEach(function (value, key) {
      if (isTrackingKey(key)) return;
      if (key === 'q' || key === 'type' || key === 'page' || key === 'sort_by' || key === 'sort') return;
      if (key === 'options' || key === 'options[prefix]' || key === 'options[unavailable_products]') return;
      if (PREVIEW_KEYS[key] || key === 'sfs_native' || key === 'section_id') return;
      if (TRANSPORT[key]) {
        if (key === 'sfs_collection' && value) hard.push(key + '=' + value);
        return;
      }
      if (/^sfs_(brand|series|amps|voltage|mounting|trip_technology|condition|aic_min)$/.test(key) || key === 'facets') {
        var valid = !!value.trim() && value.length <= 200 && !/[\u0000-\u001f\u007f<>{}%]/.test(value);
        if (key === 'facets') {
          valid = validFacets(value);
        }
        if (valid) engineFilters.push(key + '=' + value);
        else hard.push(key + '=' + value);
        return;
      }
      if (key === 'sfs_poles' || key === 'filter.p.m.breakers.poles' || key === 'filter.v.availability') return;
      if (key.indexOf('filter.') === 0) {
        extra.push(key + '=' + value);
        return;
      }
      // Unrelated URL keys do not constrain the product set.
      if (key.indexOf('sfs_') === 0 || key.indexOf('options[') === 0) hard.push(key + '=' + value);
    });
    var mappedSort = {price_asc:'price-ascending', price_desc:'price-descending', title_asc:'title-ascending', title_desc:'title-descending'};
    engineSort = mappedSort[engineSort] || engineSort;
    if (engineSort && !SHOPIFY_SORTS[engineSort]) hard.push('sort=' + engineSort);
    if (sortBy && !SHOPIFY_SORTS[sortBy]) hard.push('sort_by=' + sortBy);
    var aggregateValues = url.searchParams.getAll('options');
    var options = aggregateValues.length === 1 ? aggregateOptions(aggregateValues[0]) : null;
    if (aggregateValues.length && !options) hard.push('options');
    ['options[prefix]', 'options[unavailable_products]'].forEach(function (key) {
      var values = url.searchParams.getAll(key);
      var name = key === 'options[prefix]' ? 'prefix' : 'unavailable_products';
      if (options && Object.prototype.hasOwnProperty.call(options, name) && values.length && options[name] !== values[0]) hard.push(key);
      var pattern = key === 'options[prefix]' ? /^(last|none)$/ : /^(last|hide|show)$/;
      if (values.length > 1 || (values.length && !pattern.test(values[0]))) values.forEach(function (value) { hard.push(key + '=' + value); });
    });
    if (url.searchParams.has('page') && !/^[1-9]\d*$/.test(url.searchParams.get('page'))) hard.push('page=' + url.searchParams.get('page'));
    var types = url.searchParams.getAll('type');
    if (types.length > 1 || (types.length && types[0] !== 'product')) hard.push('type');
    if (url.searchParams.getAll('page').length > 1) hard.push('page');
    var sort = '';
    if (sortBy && SHOPIFY_SORTS[sortBy]) sort = sortBy;
    else if (engineSort && SHOPIFY_SORTS[engineSort]) sort = engineSort;
    return {
      q: q,
      type: types.length ? types[0] : 'product',
      collection: collection,
      sort: sort,
      page: pageNumber(url.searchParams.get('page')),
      poles: poles,
      availability: availability,
      extraFilters: extra,
      hardUnsupported: hard,
      engineFilters: engineFilters,
      sfsNative: url.searchParams.get('sfs_native') === '1',
      optionsPrefix: url.searchParams.get('options[prefix]') || (options && options.prefix) || '',
      optionsUnavailable: url.searchParams.get('options[unavailable_products]') || (options && options.unavailable_products) || ''
    };
  }

  // Match the engine's JSON and key:value|key:value facet links.
  function validFacets(raw) {
    var facets;
    try {
      facets = JSON.parse(raw);
    } catch (e) {
      facets = Object.create(null);
      var pairs = raw.split('|');
      var counts = Object.create(null);
      for (var i = 0; i < pairs.length; i += 1) {
        var pair = pairs[i].split(':');
        if (!pair[0] || !pair[1] || pair[1].length > 200) return false;
        counts[pair[0]] = (counts[pair[0]] || 0) + 1;
        if (counts[pair[0]] > 12) return false;
        facets[pair[0]] = pair[1];
      }
    }
    var keys = facets && !Array.isArray(facets) && typeof facets === 'object' ? Object.keys(facets) : [];
    return keys.length > 0 && keys.length <= 3 && keys.every(function (group) {
      if (!/^(brand_canonical|product_type|series|product_class|ampere_rating_amps|pole_count|rated_voltage_options|aic_min_options|mounting_type|neutral_connection|conditions_available)$/.test(group)) return false;
      var values = Array.isArray(facets[group]) ? facets[group] : [facets[group]];
      return values.length > 0 && values.length <= 12 && values.every(function (value) {
        return typeof value === 'string' && !!value.trim() && value.length <= 200;
      });
    });
  }

  function searchPlan(state) {
    var hard = (state && state.hardUnsupported) || [];
    var typeOk = !state || !state.type || state.type === 'product';
    var exactForNative = !!(state && state.q && !state.collection && hard.length === 0 && !(state.engineFilters && state.engineFilters.length) && typeOk);
    var exactForEngine = !!(state && state.q && !state.collection && hard.length === 0 && typeOk) &&
      !(state.availability && state.availability.length) &&
      !(state.extraFilters && state.extraFilters.length);
    return {
      exactForNative: exactForNative,
      exactForEngine: exactForEngine,
      unsupported: hard.slice()
    };
  }

  function collectionPlan(state) {
    var filters = (state && state.filters) || {};
    var unsupported = [];
    var poles = [];
    var badPoles = false;
    Object.keys(filters).forEach(function (group) {
      var values = filters[group] || [];
      if (!values.length) return;
      if (group === 'poles') {
        values.forEach(function (label) {
          if (/^[1-4] Pole$/.test(label)) poles.push(label);
          else badPoles = true;
        });
        if (badPoles) unsupported.push('poles');
      } else unsupported.push(group);
    });
    var sort = (state && state.sort) || '';
    var badSort = !!(sort && !SHOPIFY_SORTS[sort]);
    if (badSort) unsupported.push('sort');
    return {
      poles: poles,
      unsupported: unsupported,
      exactForNative: unsupported.length === 0,
      exactForEngine: !badSort && !badPoles
    };
  }

  function requestKey(state) {
    return JSON.stringify({
      q: (state && state.q) || '',
      type: (state && state.type) || 'product',
      prefix: (state && state.optionsPrefix) || '',
      unavailable: (state && state.optionsUnavailable) || '',
      engineFilters: ((state && state.engineFilters) || []).slice().sort(),
      filters: (state && state.filters) || {},
      c: (state && state.collection) || '',
      s: (state && state.sort) || '',
      p: (state && state.page) || 1,
      poles: ((state && state.poles) || []).slice().sort(),
      availability: ((state && state.availability) || []).slice().sort(),
      extra: ((state && state.extraFilters) || []).slice().sort(),
      hard: ((state && state.hardUnsupported) || []).slice().sort()
    });
  }

  function sessionKey(state) {
    var cfg = typeof window !== 'undefined' && window.SFS_NATIVE_FALLBACK;
    return String(cfg && cfg.themeId || '') + '|' + normQuery(state && state.q) + '|' + ((state && state.collection) || '');
  }

  function collectionSession(host, state) {
    return {
      q: '',
      collection: (host && host.collectionHandle) || (state && state.collection) || '',
      sort: state && state.sort || '',
      page: state && state.page || 1,
      poles: collectionPlan(state || {}).poles,
      filters: (state && state.filters) || {},
      availability: [],
      extraFilters: [],
      hardUnsupported: collectionPlan(state || {}).exactForNative ? [] : ['held']
    };
  }

  function appliedSearchState(state) {
    return {
      q: state.q,
      type: state.type,
      collection: '',
      sort: state.sort,
      page: state.page,
      poles: state.hardUnsupported.length ? [] : state.poles.slice(),
      availability: state.availability.slice(),
      extraFilters: state.extraFilters.slice(),
      hardUnsupported: state.hardUnsupported.slice(),
      engineFilters: (state.engineFilters || []).slice(),
      optionsPrefix: state.optionsPrefix,
      optionsUnavailable: state.optionsUnavailable,
      sfsNative: false
    };
  }

  function nativeDocumentUrl(href) {
    var state = typeof href === 'string' ? readState(href) : href;
    var plan = searchPlan(state);
    var base = new URL(typeof href === 'string' ? href : originBase(), originBase());
    if (state.collection) {
      return { url: base.pathname + base.search, unsupported: true, exactForNative: false, exactForEngine: false, state: state };
    }
    if (typeof href === 'string' && !plan.exactForNative) {
      base.pathname = '/search';
      copyPreview(base, new URL(originBase()));
      return { url: base.pathname + base.search, unsupported: true, exactForNative: false, exactForEngine: plan.exactForEngine, state: state };
    }
    var target = new URL('/search', base.origin);
    if (state.q) target.searchParams.set('q', state.q);
    if (!state.type || state.type === 'product') target.searchParams.set('type', 'product');
    else target.searchParams.set('type', state.type);
    if (state.optionsPrefix === 'last' || state.optionsPrefix === 'none') {
      target.searchParams.set('options[prefix]', state.optionsPrefix);
    }
    if (state.optionsUnavailable === 'show' || state.optionsUnavailable === 'hide' || state.optionsUnavailable === 'last') {
      target.searchParams.set('options[unavailable_products]', state.optionsUnavailable);
    }
    copyPreview(target, base);
    if (state.sort && SHOPIFY_SORTS[state.sort]) target.searchParams.set('sort_by', state.sort);
    if (state.page > 1) target.searchParams.set('page', String(state.page));
    if (plan.exactForNative) {
      state.poles.forEach(function (label) {
        target.searchParams.append('filter.p.m.breakers.poles', label.charAt(0));
      });
    }
    (state.availability || []).forEach(function (value) {
      target.searchParams.append('filter.v.availability', value);
    });
    (state.extraFilters || []).forEach(function (pair) {
      var idx = pair.indexOf('=');
      if (idx > 0) target.searchParams.append(pair.slice(0, idx), pair.slice(idx + 1));
    });
    (state.engineFilters || []).forEach(function (pair) {
      var idx = pair.indexOf('=');
      target.searchParams.append(pair.slice(0, idx), pair.slice(idx + 1));
    });
    if (!plan.exactForNative) {
      (state.hardUnsupported || []).forEach(function (token) {
        var idx = token.indexOf('=');
        var key = idx === -1 ? token : token.slice(0, idx);
        var value = idx === -1 ? '' : token.slice(idx + 1);
        target.searchParams.append(key, value);
      });
      state.poles.forEach(function (label) {
        target.searchParams.append('sfs_poles', label);
      });
    }
    if (state.sfsNative) target.searchParams.set('sfs_native', '1');
    return {
      url: target.pathname + target.search,
      unsupported: !plan.exactForNative,
      exactForNative: plan.exactForNative,
      exactForEngine: plan.exactForEngine,
      state: state
    };
  }

  function presentHref(href) {
    if (!href) return '';
    var url;
    try { url = new URL(href, originBase()); } catch (e) { return ''; }
    var base = new URL(originBase());
    if (url.origin !== base.origin || !/^https?:$/.test(url.protocol) || url.username || url.password) return '';
    copyPreview(url, base);
    if (url.pathname === '/a/search' || url.pathname === '/a/search/') {
      var state = readState(url.href);
      if (enabled() && pageInCooldown() && !hasNarrowing(state) && !state.engineFilters.length) return fallbackSearchUrl(url.href);
      return url.pathname + url.search + url.hash;
    }
    if (url.pathname === '/search' || /^\/(?:products|collections|pages)\//.test(url.pathname)) return url.pathname + url.search + url.hash;
    return '';
  }

  function nativePredictiveUrl(raw) {
    var base = new URL(originBase());
    var url;
    try { url = new URL(raw, base); } catch (e) { return ''; }
    if (url.origin !== base.origin || url.username || url.password || !/^https?:$/.test(url.protocol)) return '';
    var target = new URL('/search/suggest', base);
    ['q', 'section_id'].forEach(function (key) {
      var value = url.searchParams.get(key);
      if (value) target.searchParams.set(key, value);
    });
    target.searchParams.set('resources[type]', 'product');
    target.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,vendor');
    copyPreview(target, base);
    copyPreview(target, url);
    return target.pathname + target.search;
  }

  function engineSearchUrl(state) {
    var plan = searchPlan(state);
    if (!plan.exactForEngine) return '';
    var url = new URL('/a/search', originBase());
    url.searchParams.set('q', state.q);
    url.searchParams.set('type', 'product');
    url.searchParams.set('sfs_fragment', '1');
    url.searchParams.set('sfs_filters', '1');
    (state.engineFilters || []).forEach(function (pair) {
      var idx = pair.indexOf('=');
      url.searchParams.append(pair.slice(0, idx), pair.slice(idx + 1));
    });
    (state.poles || []).forEach(function (label) { url.searchParams.append('sfs_poles', label); });
    if (state.sort && SHOPIFY_SORTS[state.sort]) {
      var engineSort = {'price-ascending':'price_asc', 'price-descending':'price_desc', 'title-ascending':'title_asc', 'title-descending':'title_desc'};
      url.searchParams.set('sort', engineSort[state.sort] || state.sort);
    }
    if (state.page > 1) url.searchParams.set('page', String(state.page));
    if (state.optionsPrefix === 'last' || state.optionsPrefix === 'none') {
      url.searchParams.set('options[prefix]', state.optionsPrefix);
    }
    if (state.optionsUnavailable === 'show' || state.optionsUnavailable === 'hide' || state.optionsUnavailable === 'last') {
      url.searchParams.set('options[unavailable_products]', state.optionsUnavailable);
    }
    try { copyPreview(url, new URL(originBase())); } catch (e) {}
    return url.pathname + url.search;
  }

  function sectionIdFrom(root) {
    var scope = root && root.querySelector ? root : (typeof document !== 'undefined' ? document : null);
    if (!scope || !scope.querySelector) return '';
    var own = scope.getAttribute && (scope.getAttribute('data-native-section-id') || scope.getAttribute('data-section-id'));
    if (own) return own;
    var named = scope.querySelector('[data-native-section-id]');
    if (named && named.getAttribute('data-native-section-id')) return named.getAttribute('data-native-section-id');
    var section = scope.querySelector('[data-section-id]');
    return section ? (section.getAttribute('data-section-id') || '') : '';
  }

  function nativeSearchSectionUrl(state) {
    var built = nativeDocumentUrl(state);
    var url = new URL(built.url, originBase());
    var sectionId = typeof window !== 'undefined' && /^\/a\/search\/?$/.test(window.location.pathname) ? 'main-search-page' :
      nativeSectionId || sectionIdFrom(typeof document !== 'undefined' ? document.querySelector('filter-component.plp-shell') : null) || 'main-search-page';
    if (sectionId) url.searchParams.set('section_id', sectionId);
    return { url: url.pathname + url.search, sectionId: sectionId, shopper: built.url };
  }

  function nativeCollectionUrl(host, state, mode) {
    var currentState = readState(originBase());
    if (currentState.q || currentState.hardUnsupported.length) {
      throw Object.assign(new Error('unsupported collection constraints'), { sfsReason: 'invalid_payload' });
    }
    var path = (host && host.collectionUrl) || (typeof window !== 'undefined' && window.location.pathname) || '/';
    var url = new URL(path, originBase());
    var expectedPath = '/collections/' + (host && host.collectionHandle || '');
    if (url.origin !== new URL(originBase()).origin || url.username || url.password ||
        !/^\/collections\/[a-z0-9-]+\/?$/.test(url.pathname) || url.pathname.replace(/\/$/, '') !== expectedPath) {
      throw Object.assign(new Error('invalid collection URL'), { sfsReason: 'invalid_payload' });
    }
    url.search = '';
    try { copyPreview(url, new URL(originBase())); } catch (e) {}
    var plan = collectionPlan(state);
    if (plan.exactForNative) {
      plan.poles.forEach(function (label) {
        url.searchParams.append('filter.p.m.breakers.poles', label.charAt(0));
      });
    }
    if (state && state.sort && SHOPIFY_SORTS[state.sort]) {
      url.searchParams.set('sort_by', state.sort);
    }
    var page = state && state.page || 1;
    if (page > 1) url.searchParams.set('page', String(page));
    if (typeof window !== 'undefined' && window.location) {
      var current = new URL(window.location.href);
      current.searchParams.getAll('filter.v.availability').forEach(function (value) {
        url.searchParams.append('filter.v.availability', value);
      });
      current.searchParams.forEach(function (value, key) {
        if (key.indexOf('filter.') === 0 && key !== 'filter.p.m.breakers.poles' && key !== 'filter.v.availability') {
          url.searchParams.append(key, value);
        }
      });
    }
    var shopper = url.pathname + url.search;
    if (mode === 'section') {
      var sectionId = sectionIdFrom(host);
      if (sectionId) url.searchParams.set('section_id', sectionId);
    }
    return { url: url.pathname + url.search, shopper: shopper, sectionId: sectionIdFrom(host) };
  }

  function countRenderable(root) {
    if (!root || !root.querySelectorAll) return 0;
    var cards = root.querySelectorAll('.product-card');
    var total = 0;
    for (var i = 0; i < cards.length; i += 1) {
      var card = cards[i];
      var link = card.querySelector && card.querySelector('a[href*="/products/"]');
      if (!link) continue;
      try {
        var url = new URL(link.getAttribute('href'), originBase());
        if (url.origin === new URL(originBase()).origin && !url.username && !url.password && /^\/(?:collections\/[a-z0-9-]+\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname)) total += 1;
      } catch (e) {}
    }
    return total;
  }

  function parseTotal(text) {
    var raw = String(text || '').trim();
    if (/^\(\d[\d,]*\)$/.test(raw)) raw = raw.slice(1, -1);
    if (/-\s*\d|\d\.\d/.test(raw)) return null;
    var numbers = raw.match(/(?:^|\s)\d[\d,]*(?=\s|$)/g);
    if (!numbers || numbers.length !== 1) return null;
    var token = numbers[0].trim();
    if (!/^(?:0|[1-9]\d*|[1-9]\d{0,2}(?:,\d{3})+)$/.test(token)) return null;
    var value = Number(token.replace(/,/g, ''));
    return Number.isSafeInteger(value) && value >= 0 ? value : null;
  }

  function readTotal(root) {
    if (!root || !root.querySelector) return null;
    var marked = root.querySelector('[data-search-results-total]');
    if (marked) {
      var attr = marked.getAttribute && marked.getAttribute('data-search-results-total');
      if (attr != null && attr !== '') return /^(?:0|[1-9]\d*)$/.test(attr) && Number.isSafeInteger(Number(attr)) ? Number(attr) : null;
      var fromText = parseTotal(marked.textContent);
      if (fromText != null) return fromText;
    }
    var count = root.querySelector('[data-sfs-collection-count-text], .collection-count, .plp-heading-count');
    if (count) return parseTotal(count.textContent);
    count = root.querySelector('.sfs-result-count');
    if (count) return parseTotal(count.textContent);
    return null;
  }

  function classifySuggest(data) {
    if (!data || typeof data !== 'object' || Array.isArray(data) || data.error) {
      return { reason: 'invalid_payload', usable: 0 };
    }
    if (!Array.isArray(data.products)) return { reason: 'invalid_payload', usable: 0 };
    var usable = 0;
    data.products.forEach(function (item) {
      if (item && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(item.handle)) usable += 1;
    });
    var pinned = data.pinned;
    if (pinned && typeof pinned === 'object' && !Array.isArray(pinned) && typeof pinned.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(pinned.handle)) {
      usable += 1;
    }
    if (Array.isArray(pinned)) {
      pinned.forEach(function (item) {
        if (item && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(item.handle)) usable += 1;
      });
    }
    if (Array.isArray(pinned) || usable < data.products.length + (pinned ? 1 : 0)) return { reason: 'invalid_payload', usable: 0 };
    if (usable > 0) return { reason: null, usable: usable };
    if (data.products.length || (pinned && (!Array.isArray(pinned) || pinned.length))) {
      return { reason: 'invalid_payload', usable: 0 };
    }
    return { reason: 'engine_zero', usable: 0 };
  }

  function classifyEngineDocument(root, state) {
    if (!root || !root.querySelector) return { reason: 'invalid_payload', action: 'fail', cards: 0, total: null };
    var scope = root.querySelector('#shopify-section-proxy-search, [data-sfs-collection-response]') || root;
    var grid = scope.querySelector('.search-results-body, .collection-results-body, [data-sfs-collection-grid], .product-card, .sfs-empty');
    var cards = countRenderable(scope);
    var total = readTotal(scope);
    var page = (state && state.page) || 1;
    var emptyMarker = scope.querySelector('.sfs-empty, .no-result-text, .search-no-result');
    if (!grid && cards === 0 && total == null && !emptyMarker) {
      return { reason: 'invalid_payload', action: 'fail', cards: 0, total: null };
    }
    if (cards > 0 && total > 0) return { reason: null, action: 'engine', cards: cards, total: total };
    if (cards > 0 || scope.querySelector('.product-card')) return { reason: 'invalid_payload', action: 'fail', cards: 0, total: total };
    if (total > 0 && page > 1) return { reason: null, action: 'engine', pastEnd: true, cards: 0, total: total };
    if (total > 0) return { reason: 'invalid_payload', action: 'fail', cards: 0, total: total };
    if (total === 0) return { reason: 'engine_zero', action: 'native', cards: 0, total: total || 0 };
    if (page === 1 && total == null && emptyMarker &&
        !scope.querySelector('[data-search-results-total], [data-sfs-collection-count-text], .collection-count, .plp-heading-count, .sfs-result-count')) {
      return { reason: 'engine_zero', action: 'native', cards: 0, total: 0 };
    }
    return { reason: 'invalid_payload', action: 'fail', cards: 0, total: total };
  }

  function classifyCollectionSource(source, state) {
    if (!source || !source.querySelector) return { reason: 'invalid_payload', action: 'fail', cards: 0, total: null };
    var grid = source.querySelector('[data-sfs-collection-grid]');
    var countNode = source.querySelector('[data-sfs-collection-count-text]');
    if (!grid || !countNode) return { reason: 'invalid_payload', action: 'fail', cards: 0, total: null };
    var cards = countRenderable(grid);
    var total = parseTotal(countNode.textContent);
    var page = (state && state.page) || 1;
    if (total == null) return { reason: 'invalid_payload', action: 'fail', cards: cards, total: null };
    if (cards > 0 && total > 0) return { reason: null, action: 'engine', cards: cards, total: total };
    if (cards > 0 || grid.querySelector('.product-card')) return { reason: 'invalid_payload', action: 'fail', cards: 0, total: total };
    if (total > 0 && page > 1) return { reason: null, action: 'engine', pastEnd: true, cards: 0, total: total };
    if (total > 0) return { reason: 'invalid_payload', action: 'fail', cards: 0, total: total };
    return { reason: 'engine_zero', action: 'native', cards: 0, total: 0 };
  }

  function inspectCollectionResponse(source, state) {
    sanitizeResultMarkup(source);
    var verdict = classifyCollectionSource(source, state);
    return verdict;
  }

  function classifyEngineError(err) {
    if (!err) return 'network';
    if (err.sfsReason === 'timeout' || err.sfsTimedOut) return 'timeout';
    if (err.sfsReason === 'invalid_payload') return 'invalid_payload';
    if (err.sfsReason === 'aborted' || err.sfsAborted) return 'aborted';
    if (err.name === 'AbortError') return 'aborted';
    var status = err.status || 0;
    var message = String(err.message || '');
    var match = message.match(/(?:http|returned)\s+(\d+)/i);
    if (!status && match) status = parseInt(match[1], 10);
    if (status) return 'http_error';
    return 'network';
  }

  function record(reason, meta) {
    var entry = {
      reason: reason,
      at: now(),
      surface: meta && meta.surface || ''
    };
    diagnostics.push(entry);
    if (diagnostics.length > 20) diagnostics = diagnostics.slice(-20);
    try { storageSet(DIAG_KEY, JSON.stringify(diagnostics)); } catch (e) {}
    return entry;
  }

  function noteFailure(reason, meta) {
    var entry = record(reason, meta);
    if (COOLDOWN_REASONS[reason]) {
      var value = JSON.stringify({ until: now() + cooldownMs() });
      storageSet(COOL_KEY, value);
      if (!meta || meta.surface === 'search') storageSet(PAGE_COOL_KEY, value);
    }
    return entry;
  }

  function pageInCooldown() { return inCooldown(PAGE_COOL_KEY); }

  function inCooldown(key) {
    var raw = storageGet(key || COOL_KEY);
    if (!raw) return false;
    try {
      var parsed = JSON.parse(raw);
      return !!(parsed && typeof parsed.until === 'number' && parsed.until > now());
    } catch (e) {
      return false;
    }
  }

  function clearCooldown() {
    storageRemove(COOL_KEY);
    storageRemove(PAGE_COOL_KEY);
  }

  function sourceStorageKey(state) {
    return SOURCE_PREFIX + sessionKey(state);
  }

  function rememberSource(source, state) {
    // This document can sleep in the page cache while another document changes
    // the shared session record for the same query. Keep its displayed owner.
    documentSource = {
      key: sourceStorageKey(state),
      value: JSON.stringify({ source: source, request: requestKey(state), page: state.page || 1, at: now() }),
      source: source
    };
    storageSet(documentSource.key, documentSource.value);
    markNativeMode(source === 'native');
  }

  function readSource(state) {
    var raw = storageGet(sourceStorageKey(state));
    if (!raw) return '';
    try {
      var parsed = JSON.parse(raw);
      return parsed && parsed.source || '';
    } catch (e) {
      return '';
    }
  }

  function clearSource(state) {
    storageRemove(sourceStorageKey(state));
  }

  function pageForSourceChange(previous, next, page) {
    if (previous && previous !== next) return 1;
    return page || 1;
  }

  function hasNarrowing(state) {
    return (state.page || 1) > 1 ||
      (state.poles && state.poles.length) ||
      (state.availability && state.availability.length) ||
      (state.extraFilters && state.extraFilters.length) ||
      (state.hardUnsupported && state.hardUnsupported.length) ||
      (state.filters && Object.keys(state.filters).some(function (key) { return state.filters[key] && state.filters[key].length; }));
  }

  function shouldSkipEngine(state, continuation) {
    if (!enabled()) return false;
    if (state && state.sfsNative) return !!(continuation || hasNarrowing(state) || pageInCooldown());
    var source = readSource(state);
    if (source === 'engine') return pageInCooldown();
    if (source === 'native') {
      if (continuation || hasNarrowing(state) || pageInCooldown()) return true;
      clearSource(state);
      return false;
    }
    return pageInCooldown();
  }

  function shouldSkipCollectionEngine(host, state) {
    if (!enabled()) return false;
    var current = readState(originBase());
    if (current.sfsNative || current.q || current.hardUnsupported.length) return true;
    var session = collectionSession(host, state || (host && host.desiredState) || { filters: {}, sort: '', page: 1 });
    var source = readSource(session);
    if (source === 'engine') return inCooldown();
    if (source === 'native') return true;
    if (host && host._sfsNativeCommitted) return true;
    return inCooldown();
  }

  function blockOptionSearch() {
    if (!enabled() || typeof window === 'undefined') return false;
    var state = readState(window.location.href);
    if (state.collection && !state.q) {
      return shouldSkipCollectionEngine({ collectionHandle: state.collection }, { filters: {}, sort: state.sort, page: state.page });
    }
    return shouldSkipEngine(state, true);
  }

  function beginRequest(surface) {
    var name = generations[surface] == null ? 'search' : surface;
    if (name === 'search' && restoreFilterRow) restoreFilterRow();
    generations[name] += 1;
    if (name === 'search' && searchAbort) {
      try { searchAbort.abort(); } catch (e) {}
      searchAbort = null;
    }
    return generations[name];
  }

  function isCurrent(surface, token) {
    var name = generations[surface] == null ? 'search' : surface;
    return generations[name] === token;
  }

  function lastDiagnostic() {
    if (diagnostics.length) return diagnostics[diagnostics.length - 1];
    try {
      var parsed = JSON.parse(storageGet(DIAG_KEY) || '[]');
      return parsed.length ? parsed[parsed.length - 1] : null;
    } catch (e) {
      return null;
    }
  }

  function fetcher() {
    if (typeof window !== 'undefined' && typeof window.fetch === 'function') return window.fetch.bind(window);
    if (typeof fetch === 'function') return fetch;
    return null;
  }

  function fetchBudget(url, ms, ownerSignal, surface) {
    var go = fetcher();
    if (!go) return Promise.reject(Object.assign(new Error('network'), { sfsReason: 'network' }));
    var controller = new AbortController();
    if (!surface || surface === 'search') searchAbort = controller;
    var timer;
    var abortOwner;
    var limit = new Promise(function (_, reject) {
      abortOwner = function () {
        controller.abort();
        reject(Object.assign(new Error('aborted'), { sfsReason: 'aborted' }));
      };
      if (ownerSignal) {
        if (ownerSignal.aborted) return abortOwner();
        ownerSignal.addEventListener('abort', abortOwner, { once: true });
      }
      timer = setTimeout(function () {
        controller.abort();
        reject(Object.assign(new Error('timeout'), { sfsReason: 'timeout' }));
      }, ms || timeoutMs());
    });
    return Promise.race([Promise.resolve().then(function () {
      if (ownerSignal && ownerSignal.aborted) throw Object.assign(new Error('aborted'), { sfsReason: 'aborted' });
      return go(url, { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: controller.signal });
    }).then(function (response) {
      if (!response || !response.ok) throw Object.assign(new Error('http error'), { status: response && response.status || 0 });
      return response.text().then(function (html) {
        if (surface !== 'dropdown') return html;
        // Transfer sanitized nodes without serializing or parsing them again.
        var pieces = String(html).split('<!-- /// -->');
        if (pieces.length < 3) throw Object.assign(new Error('invalid native fragment'), { sfsReason: 'invalid_payload' });
        return parseHtml(pieces[1]).body;
      });
    }), limit]).finally(function () {
      clearTimeout(timer);
      if (ownerSignal) ownerSignal.removeEventListener('abort', abortOwner);
      if (searchAbort === controller) searchAbort = null;
    });
  }

  function fetchSuggest(q, signal) {
    if (leavingPage || (typeof window !== 'undefined' && window.__sfsSearchCommitted)) return Promise.resolve({ stale: true });
    if (inCooldown()) return Promise.resolve({ fallback: true, reason: 'cooldown' });
    var url = new URL('/a/search', originBase());
    url.searchParams.set('sfs_endpoint', 'suggest');
    url.searchParams.set('q', q);
    copyPreview(url, new URL(originBase()));
    var go = fetcher();
    if (!go) return Promise.resolve({ fallback: true, reason: 'network' });
    var controller = new AbortController();
    var abortOwner = function () { controller.abort(); };
    if (signal) {
      if (signal.aborted) return Promise.resolve({ stale: true });
      signal.addEventListener('abort', abortOwner, { once: true });
    }
    var timedOut = false;
    var timer;
    var limit = new Promise(function (_, reject) {
      timer = setTimeout(function () {
        timedOut = true;
        controller.abort();
        reject(Object.assign(new Error('timeout'), { sfsReason: 'timeout' }));
      }, timeoutMs());
    });
    return Promise.race([Promise.resolve(go(url.pathname + url.search, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal
    })).then(function (response) {
      if (!response || !response.ok) throw Object.assign(new Error('http error'), { status: response && response.status || 0 });
      return response.json().catch(function () {
        throw Object.assign(new Error('invalid payload'), { sfsReason: 'invalid_payload' });
      });
    }), limit]).then(function (data) {
      if (leavingPage || window.__sfsSearchCommitted || (signal && signal.aborted)) return { stale: true };
      var verdict = classifySuggest(data);
      if (verdict.reason === 'engine_zero') {
        record('engine_zero', { surface: 'dropdown' });
        return { fallback: true, reason: 'engine_zero' };
      }
      if (verdict.reason) throw Object.assign(new Error('invalid payload'), { sfsReason: verdict.reason });
      return { data: data, source: 'engine' };
    }).catch(function (err) {
      if (leavingPage || window.__sfsSearchCommitted || (signal && signal.aborted) || (err && err.name === 'AbortError' && !timedOut)) return { stale: true };
      var reason = classifyEngineError(err);
      noteFailure(reason, { surface: 'dropdown' });
      return { fallback: true, reason: reason };
    }).finally(function () {
      clearTimeout(timer);
      if (signal) signal.removeEventListener('abort', abortOwner);
    });
  }

  function parseHtml(html) {
    if (typeof DOMParser === 'undefined') {
      var error = new Error('invalid payload');
      error.sfsReason = 'invalid_payload';
      throw error;
    }
    return sanitizeResultMarkup(new DOMParser().parseFromString(String(html || ''), 'text/html'));
  }

  function resultsRoot() {
    if (typeof document === 'undefined') return null;
    return document.querySelector('.search-results-wrapper, .collection-results-wrapper');
  }

  function setBusy(busy) {
    var root = resultsRoot();
    if (!root) return;
    root.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (root.classList) {
      if (busy) root.classList.add('sfs-results-loading');
      else root.classList.remove('sfs-results-loading');
    }
  }

  function markNativeMode(on) {
    if (typeof document === 'undefined' || !document.documentElement) return;
    availabilityOn = !!on;
    refreshFilterAvailability();
    if (on) document.documentElement.dataset.sfsNativeMode = '1';
    else if (document.documentElement.dataset) delete document.documentElement.dataset.sfsNativeMode;
  }

  // Both the upfront state and the click hold use this exact capability test.
  function nativeConstraintSupported(state, host, plan) {
    plan = plan || searchPlan(state);
    var names = nativeFacetNames;
    if (host) {
      try { names = JSON.parse(host.getAttribute('data-sfs-native-facets') || '[]'); } catch (e) { names = []; }
    }
    if (!Array.isArray(names) || !plan.exactForNative) return false;
    if (state.poles && state.poles.length &&
        (names.indexOf('filter.p.m.breakers.poles') === -1 ||
         (host && host.getAttribute('data-sfs-native-poles') !== 'true'))) return false;
    if (state.availability && state.availability.length && names.indexOf('filter.v.availability') === -1) return false;
    return (state.extraFilters || []).every(function (pair) { return names.indexOf(pair.split('=')[0]) !== -1; });
  }

  // Shopify pagination can print its options hash as one query parameter.
  // Keep each supported option as a plain bracket parameter on outgoing URLs.
  function normalizeOptionsParams(params) {
    var values = params.getAll('options');
    var options = values.length === 1 ? aggregateOptions(values[0]) : null;
    if (options) {
      Object.keys(options).forEach(function (name) {
        var key = 'options[' + name + ']';
        if (!params.has(key)) params.set(key, options[name]);
      });
    }
    if (values.some(function (value) { return !/^[a-z0-9_-]+$/i.test(value); })) params.delete('options');
  }

  function retryFiltersUrl(host) {
    var current = new URL(originBase());
    var url = host && typeof host.visibleUrl === 'function' ?
      new URL(host.visibleUrl(host.currentState).toString(), current) : new URL(current.href);
    url.pathname = '/a/search';
    if (host && host.collectionHandle) url.searchParams.set('sfs_collection', host.collectionHandle);
    ['sfs_native', 'section_id', 'page'].forEach(function (key) { url.searchParams.delete(key); });
    if (!url.searchParams.has('q')) url.searchParams.set('q', current.searchParams.get('q') || '');
    copyPreview(url, current);
    normalizeOptionsParams(url.searchParams);
    return url;
  }

  function hasActiveRetryFilters(url) {
    return Array.from(url.searchParams).some(function (pair) {
      return !!pair[1].trim() && (pair[0].indexOf('filter.') === 0 || pair[0] === 'facets' ||
        /^sfs_(poles|brand|series|amps|voltage|mounting|trip_technology|condition|aic_min)$/.test(pair[0]));
    });
  }

  function normalizeResultOptions(owner) {
    owner.querySelectorAll('a[href]').forEach(function (link) {
      var raw = link.getAttribute('href');
      var url;
      try { url = new URL(raw, originBase()); } catch (e) { return; }
      if (url.origin !== new URL(originBase()).origin || !url.searchParams.has('options')) return;
      normalizeOptionsParams(url.searchParams);
      var next = url.pathname + url.search + url.hash;
      if (raw !== next) link.setAttribute('href', next);
    });
    owner.querySelectorAll('input[name="options"]').forEach(function (input) {
      if (/^[a-z0-9_-]+$/i.test(input.value)) return;
      var options = aggregateOptions(input.value);
      var form = input.form || input.closest('form');
      if (options && form) Object.keys(options).forEach(function (name) {
        var key = 'options[' + name + ']';
        var exists = Array.from(form.elements).some(function (control) { return control.name === key; });
        if (exists) return;
        var replacement = document.createElement('input');
        replacement.type = 'hidden';
        replacement.name = key;
        replacement.value = options[name];
        form.appendChild(replacement);
      });
      input.remove();
    });
  }

  function unavailableControl(control, owner) {
    if (control.closest('.filter-active, search-active-filters, .collection-active-filters, [data-sfs-active-controls], [data-sfs-native-active-controls]')) return false;
    var row = control.closest('[data-sfs-filter-item], [data-sfs-query-option-item], .filter-item, .filter-section-list-item');
    var link = control.matches('a[href]') ? control : row && row.querySelector('[data-sfs-filter-link], [data-sfs-query-filter-link], [data-sfs-native-link]');
    var input = control.matches('input') ? control : row && row.querySelector('input');
    // Removal always remains possible, including constraints unavailable here.
    if ((input && input.checked) || (link && link.getAttribute('aria-current') === 'true') ||
        (row && row.hasAttribute('data-sfs-selected'))) return false;
    if (owner.matches('collection-search-filters') && link && link.dataset.sfsGroup &&
        typeof owner.stateWithSpecificToggle === 'function') {
      var state = owner.stateWithSpecificToggle(owner.currentState, link.dataset.sfsGroup, link.dataset.sfsLabel);
      var plan = collectionPlan(state);
      return !nativeConstraintSupported({ poles: plan.poles }, owner, plan);
    }
    var url = new URL(link ? link.href : originBase(), originBase());
    if (!link && input && input.name) {
      url.searchParams.append(input.name, input.value);
    }
    var state = readState(url.href);
    if (owner.matches('collection-search-filters')) {
      return !nativeConstraintSupported(state, owner, { exactForNative: !state.q &&
        !state.hardUnsupported.length && !state.engineFilters.length });
    }
    state.q = state.q || readState(originBase()).q;
    return !nativeConstraintSupported(state, owner);
  }

  function syncBlockedDrawerButton() {
    if (typeof document === 'undefined' || !document.querySelectorAll || !document.documentElement) return;
    var blocked = /^\/search\/?$/.test(window.location.pathname) &&
      document.documentElement.hasAttribute('data-sfs-filter-blocked') &&
      typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 991.98px)').matches;
    document.querySelectorAll('.filter-drawer-footer .filter-drawer-close').forEach(function (button) {
      var original = button.querySelector('[data-sfs-drawer-results-label]');
      if (blocked && !original) {
        // Keep the live count connected so result updates still reach it.
        original = document.createElement('span');
        original.setAttribute('data-sfs-drawer-results-label', '');
        original.hidden = true;
        while (button.firstChild) original.appendChild(button.firstChild);
        button.appendChild(original);
        var close = document.createElement('span');
        close.setAttribute('data-sfs-drawer-close-label', '');
        close.textContent = 'Close';
        button.appendChild(close);
      } else if (!blocked && original) {
        while (original.firstChild) button.insertBefore(original.firstChild, original);
        original.remove();
        var label = button.querySelector('[data-sfs-drawer-close-label]');
        if (label) label.remove();
      }
    });
  }

  function refreshFilterAvailability() {
    if (!enabled() || typeof document === 'undefined' || !document.querySelectorAll) return;
    if (availabilityObserver) availabilityObserver.disconnect();
    syncBlockedDrawerButton();
    document.querySelectorAll('collection-search-filters, filter-component.plp-shell').forEach(function (owner) {
      if (owner.matches('filter-component') && owner.closest('collection-search-filters')) return;
      normalizeResultOptions(owner);
      var native = availabilityOn;
      var count = 0;
      owner.querySelectorAll('.sidebar-section input[name^="filter."]:not([type="hidden"]), .sidebar-section .filter-input, [data-sfs-filter-link], [data-sfs-query-filter-link], .sidebar-section a[href*="filter."]').forEach(function (control) {
        var unavailable = native && unavailableControl(control, owner);
        if (unavailable) {
          if (!control.hasAttribute('data-sfs-native-unavailable')) {
            control.setAttribute('data-sfs-native-unavailable', control.getAttribute('aria-disabled') || '');
          }
          control.setAttribute('aria-disabled', 'true');
          count += 1;
        } else if (control.hasAttribute('data-sfs-native-unavailable')) {
          var previous = control.getAttribute('data-sfs-native-unavailable');
          if (previous) control.setAttribute('aria-disabled', previous);
          else control.removeAttribute('aria-disabled');
          control.removeAttribute('data-sfs-native-unavailable');
        }
      });
      var note = owner.querySelector('[data-sfs-native-availability-note]');
      var phoneDrawer = document.documentElement.hasAttribute('data-sfs-filter-blocked') &&
        owner.matches('filter-component') && owner.querySelector('.search-results-wrapper') &&
        typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 991.98px)').matches;
      if (count && !note) {
        note = document.createElement('p');
        note.setAttribute('data-sfs-native-availability-note', '');
        note.textContent = 'Not available for these results.';
      }
      if (note) {
        var panel = (phoneDrawer && owner.querySelector('.sidebar-section-body')) || owner.querySelector('.sidebar-section') || owner;
        if (note.parentNode !== panel) panel.insertBefore(note, panel.firstChild);
        note.hidden = !count;
      }
      owner.querySelectorAll('[data-sfs-clear-hard-filter]').forEach(function (button) {
        var phoneButton = phoneDrawer && document.documentElement.hasAttribute('data-sfs-filter-blocked');
        button.classList.toggle('btn', !!phoneButton);
        button.classList.toggle('btn-1', !!phoneButton);
      });
      var retry = owner.querySelector('[data-sfs-retry-filters]');
      var retryUrl = retryFiltersUrl(owner);
      var showRetry = native && (hasActiveRetryFilters(retryUrl) ||
        document.documentElement.hasAttribute('data-sfs-filter-blocked'));
      if (showRetry && !retry) {
        retry = document.createElement('a');
        retry.setAttribute('data-sfs-retry-filters', '');
        retry.textContent = 'Search again with these filters';
        var results = owner.querySelector('.search-results-wrapper, .collection-results-wrapper');
        if (results) results.appendChild(retry);
        else owner.insertBefore(retry, owner.firstChild);
      }
      if (retry) {
        retry.hidden = !showRetry;
        retry.setAttribute('href', retryUrl.pathname + retryUrl.search);
      }
    });
    if (availabilityObserver) availabilityObserver.observe(document.body, { childList: true, subtree: true,
      attributes: true, attributeFilter: ['href', 'checked', 'aria-current', 'data-sfs-selected', 'data-sfs-native-facets', 'data-sfs-native-poles'] });
  }

  function watchFilterAvailability() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;
    var style = document.createElement('style');
    style.textContent = '[data-sfs-native-unavailable],[data-sfs-native-unavailable] + label{opacity:.5;cursor:not-allowed}[data-sfs-native-availability-note]{font-size:.875rem;color:#666}[data-sfs-retry-filters]{display:block;margin-bottom:1rem}[data-sfs-retry-filters][hidden]{display:none}[data-sfs-clear-hard-filter]{margin-inline-end:1rem}';
    document.head.appendChild(style);
    availabilityObserver = new MutationObserver(function () {
      if (availabilityQueued) return;
      availabilityQueued = true;
      Promise.resolve().then(function () { availabilityQueued = false; refreshFilterAvailability(); });
    });
    refreshFilterAvailability();
    if (typeof window.matchMedia === 'function') {
      window.matchMedia('(max-width: 991.98px)').addEventListener('change', refreshFilterAvailability);
    }
    window.addEventListener('popstate', refreshFilterAvailability);
    window.addEventListener('sfs:results-updated', refreshFilterAvailability);
    document.addEventListener('change', refreshFilterAvailability);
    function preventUnavailable(event) {
      if (!enabled()) return;
      // The deliberate retry must reach the engine page, beyond grid delegates.
      if (event.type === 'click' && event.target && event.target.closest && event.target.closest('[data-sfs-retry-filters]')) {
        event.stopImmediatePropagation();
        return;
      }
      var target = event.target && event.target.closest && event.target.closest('[data-sfs-native-unavailable]');
      if (!target && event.target && event.target.closest) {
        var label = event.target.closest('label[for]');
        if (label) target = document.getElementById(label.htmlFor);
      }
      if (!target || !target.hasAttribute('data-sfs-native-unavailable')) return;
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    document.addEventListener('click', preventUnavailable, true);
    document.addEventListener('keydown', preventUnavailable, true);
  }

  function captureFocus() {
    if (typeof document === 'undefined') return null;
    var active = document.activeElement;
    if (!active || active === document.body) return null;
    return {
      id: active.id || '',
      href: active.getAttribute ? (active.getAttribute('href') || '') : ''
    };
  }

  function restoreFocus(saved) {
    if (typeof document === 'undefined') return;
    var target = null;
    if (saved && saved.id && document.getElementById) target = document.getElementById(saved.id);
    if (!target && saved && saved.href && document.querySelectorAll) {
      var links = document.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i += 1) {
        if (links[i].getAttribute('href') === saved.href) {
          target = links[i];
          break;
        }
      }
    }
    if (!target && document.querySelector) {
      target = document.querySelector('.search-results-header, h1.section-heading, .collection-results-header');
    }
    if (target && typeof target.focus === 'function') {
      if (target.hasAttribute && !target.hasAttribute('tabindex') && !/^(A|INPUT|BUTTON|SELECT|TEXTAREA)$/.test(target.tagName || '')) target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); } catch (e) { try { target.focus(); } catch (err) {} }
    }
  }

  function statusNode() {
    if (typeof document === 'undefined') return null;
    var node = document.querySelector('[data-sfs-results-status]');
    if (node) return node;
    if (!document.createElement) return null;
    node = document.createElement('p');
    node.setAttribute('data-sfs-results-status', '');
    node.setAttribute('role', 'status');
    node.setAttribute('aria-live', 'polite');
    var root = resultsRoot();
    if (root && root.insertBefore) root.insertBefore(node, root.firstChild);
    else if (document.body) document.body.appendChild(node);
    return node;
  }

  function setStatus(message) {
    var node = statusNode();
    if (node) node.textContent = message || '';
    return node;
  }

  function browseHref() {
    var url = new URL('/collections', originBase());
    try { copyPreview(url, new URL(originBase())); } catch (e) {}
    return url.pathname + url.search;
  }

  function clearFilterHref(state) {
    var cleaned = {
      q: state.q,
      type: state.type || 'product',
      collection: state.collection,
      sort: nativeSortValues.indexOf(state.sort) !== -1 ? state.sort : '',
      page: 1,
      poles: [],
      availability: [],
      extraFilters: [],
      hardUnsupported: [],
      optionsPrefix: state.optionsPrefix,
      optionsUnavailable: state.optionsUnavailable,
      sfsNative: true
    };
    return nativeDocumentUrl(cleaned).url;
  }

  function holdResults() {
    document.documentElement.setAttribute('data-sfs-hold-results', '');
    // Share the first deadline with the inline guard; later holds cannot extend it.
    if (window.__sfsHoldTimer) return;
    window.__sfsHoldTimer = setTimeout(function () {
      window.__sfsHoldTimer = null;
      if (!document.documentElement.hasAttribute('data-sfs-hold-results')) return;
      setStatus(availabilityOn ? UNSUPPORTED_COPY : NATIVE_FAIL_COPY);
      document.documentElement.removeAttribute('data-sfs-hold-results');
      releaseFirstPaint();
      setBusy(false);
    }, 4000);
  }

  function hasUnsupportedProductConstraint(state) {
    var hardFilter = state.hardUnsupported.some(function (token) {
      var key = token.split('=')[0];
      return key.indexOf('filter.') === 0 || key === 'facets' ||
        (key.indexOf('sfs_') === 0 && !TRANSPORT[key] && key !== 'sfs_native');
    });
    // Query, options, page and sort failures do not change filter capability.
    return hardFilter || state.engineFilters.length > 0 ||
      !nativeConstraintSupported(state, null, { exactForNative: true });
  }

  function explainHold(state) {
    releaseFirstPaint();
    setBusy(false);
    if (availabilityOn && hasUnsupportedProductConstraint(state)) {
      // A decided constraint failure needs shopper action, not a paint deadline.
      document.documentElement.setAttribute('data-sfs-filter-blocked', '');
      syncBlockedDrawerButton();
      document.documentElement.removeAttribute('data-sfs-hold-results');
    } else if (!renderedSearchState && document.documentElement) holdResults();
    if (renderedSearchUrl && window.history) window.history.replaceState(window.history.state, '', renderedSearchUrl);
    var node = setStatus(availabilityOn ? UNSUPPORTED_COPY : 'This filter cannot be applied. Try again.');
    if (!node || !node.parentNode || typeof document === 'undefined' || !document.createElement) return;
    if (node.parentNode.querySelector && node.parentNode.querySelector('[data-sfs-clear-hard-filter]')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-sfs-clear-hard-filter', '');
    if (document.documentElement.hasAttribute('data-sfs-filter-blocked') &&
        typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 991.98px)').matches) {
      button.className = 'btn btn-1';
    }
    button.textContent = CLEAR_LABEL;
    button.addEventListener('click', function () {
      window.location.assign(clearFilterHref(state));
    });
    node.parentNode.insertBefore(button, node.nextSibling);
  }

  function captureBaseline() {
    var shell = document.querySelector('filter-component.plp-shell');
    if (!shell) return;
    nativeSectionId = sectionIdFrom(shell);
    try { nativeFacetNames = JSON.parse(shell.getAttribute('data-sfs-native-facets') || '[]'); } catch (e) { nativeFacetNames = []; }
    nativeSortValues = Array.prototype.map.call(shell.querySelectorAll('input[name="sort_by"], input[name="sortBy"], select[name="sort_by"] option'), function (option) { return option.value; });
    var url = new URL(window.location.href);
    var state = readState(url.href);
    if (state.q && state.type === 'product' && !searchResponseMatches(document, state, true, nativeSectionId)) {
      holdResults();
      return;
    }
    if (url.searchParams.has('sfs_poles') || url.searchParams.has('sort')) return;
    var verdict = classifyEngineDocument(shell, state);
    if (!searchPlan(state).exactForNative || verdict.reason === 'invalid_payload') return;
    if (!nativeFiltersSupported(state)) return;
    baseline = { key: requestKey(state), shell: shell.cloneNode(true), sectionId: nativeSectionId };
    renderedSearchUrl = window.location.href;
    renderedSearchState = state;
  }

  function replaceWithClone(current, snapshot) {
    if (!current || !snapshot || !current.replaceWith || !snapshot.cloneNode) return false;
    current.replaceWith(sanitizeResultMarkup(snapshot.cloneNode(true)));
    return true;
  }

  function restoreBaseline(state) {
    if (!baseline || baseline.key !== requestKey(state)) return false;
    var container = document.createElement('div');
    var section = document.createElement('section');
    section.id = 'shopify-section-' + baseline.sectionId;
    section.appendChild(baseline.shell.cloneNode(true));
    container.appendChild(section);
    if (!searchResponseMatches(container, state, true, baseline.sectionId)) return false;
    var shell = document.querySelector('filter-component.plp-shell');
    if (!shell) return false;
    var focus = captureFocus();
    shell.replaceWith(baseline.shell.cloneNode(true));
    restoreFocus(focus);
    return true;
  }

  function importChildren(source) {
    if (!source) return [];
    var nodes = source.childNodes ? Array.prototype.slice.call(source.childNodes) : [];
    return nodes.map(function (node) {
      return document.importNode ? document.importNode(node, true) : node.cloneNode(true);
    });
  }

  function safeMarkupUrl(value) {
    if (!String(value || '').trim()) return true;
    try {
      var url = new URL(value, originBase());
      return (url.protocol === 'https:' || url.protocol === 'http:') && !url.username && !url.password;
    } catch (e) { return false; }
  }

  function sanitizeResultMarkup(root) {
    if (!root || !root.querySelectorAll) return root;
    var blocked = 'noscript, template, textarea, xmp, noembed, noframes, plaintext, title, script, iframe, object, embed, applet, base, meta, link, style, foreignObject, animate, animateMotion, animateTransform, set';
    root.querySelectorAll(blocked).forEach(function (node) { node.remove(); });
    var elements = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
    elements.forEach(function (node) {
      if (!node.attributes) return;
      Array.prototype.slice.call(node.attributes).forEach(function (attr) {
        var name = attr.name.toLowerCase();
        if (/^on/.test(name) || name === 'srcdoc' || name === 'is' ||
            (name === 'style' && /url\s*\(|expression\s*\(|@import|behavior\s*:|-moz-binding/i.test(attr.value))) {
          node.removeAttribute(attr.name);
          return;
        }
        if (/^(srcset|data-srcset)$/.test(name)) {
          var safe = attr.value.split(',').every(function (candidate) { return safeMarkupUrl(candidate.trim().split(/\s+/)[0]); });
          if (!safe) node.removeAttribute(attr.name);
          return;
        }
        if (/^(href|xlink:href|src|data-src|poster|action|formaction|cite|background|longdesc)$/.test(name)) {
          if (!safeMarkupUrl(attr.value)) node.removeAttribute(attr.name);
          else if ((name === 'href' && node.tagName.toLowerCase() === 'a') || name === 'action' || name === 'formaction') {
            var href = presentHref(attr.value);
            if (href) node.setAttribute(attr.name, href);
            else node.removeAttribute(attr.name);
          }
        }
      });
      if (node.tagName && node.tagName.toLowerCase() === 'template' && node.content) sanitizeResultMarkup(node.content);
    });
    return root;
  }

  function selectedResultValues(root, name) {
    var values = [];
    root.querySelectorAll('input[name], select[name]').forEach(function (control) {
      if (control.name !== name || control.disabled) return;
      if (/^(checkbox|radio)$/.test(control.type) && !control.checked) return;
      var selected = control.tagName.toLowerCase() === 'select' ? Array.prototype.map.call(control.selectedOptions, function (option) { return option.value; }) : [control.value];
      selected.forEach(function (value) { if (value !== '' && values.indexOf(value) === -1) values.push(value); });
    });
    return values.sort();
  }

  function searchResponseMatches(doc, state, native, sectionId) {
    var roots = doc.querySelectorAll('filter-component.plp-shell');
    if (roots.length !== 1) return !native && roots.length === 0 && !doc.querySelector('input[name="q"], input[name="type"]');
    var root = roots[0];
    if (native) {
      var wrappers = Array.prototype.filter.call(doc.querySelectorAll('[id]'), function (node) { return node.id === 'shopify-section-' + sectionId; });
      var wrapper = wrappers.length === 1 && wrappers[0];
      if (!sectionId || root.getAttribute('data-section-id') !== sectionId || !wrapper || !wrapper.contains(root)) return false;
      var primary = root.querySelectorAll('form[id="mainForm' + sectionId + '"]');
      if (primary.length !== 1 || primary[0].querySelectorAll('input[name="q"]').length !== 1 ||
          primary[0].querySelectorAll('input[name="type"]').length !== 1) return false;
      var names;
      try { names = JSON.parse(root.getAttribute('data-sfs-native-facets')); } catch (e) { return false; }
      if (!Array.isArray(names) || !names.every(function (name) { return typeof name === 'string' && name.indexOf('filter.') === 0; })) return false;
      var required = {};
      (state.poles || []).forEach(function (value) { (required['filter.p.m.breakers.poles'] || (required['filter.p.m.breakers.poles'] = [])).push(value.charAt(0)); });
      (state.availability || []).forEach(function (value) { (required['filter.v.availability'] || (required['filter.v.availability'] = [])).push(value); });
      (state.extraFilters || []).forEach(function (pair) {
        var at = pair.indexOf('=');
        var key = pair.slice(0, at);
        (required[key] || (required[key] = [])).push(pair.slice(at + 1));
      });
      root.querySelectorAll('input[name^="filter."], select[name^="filter."]').forEach(function (control) {
        if (!required[control.name]) required[control.name] = [];
      });
      if (!Object.keys(required).every(function (key) {
        var expected = required[key].filter(function (value, index, values) { return values.indexOf(value) === index; }).sort();
        var actual = selectedResultValues(root, key);
        if (/^filter\.v\.price\.(gte|lte)$/.test(key)) {
          function decimal(value) {
            if (!/^\d+(?:\.\d+)?$/.test(value)) return null;
            var parts = value.split('.');
            var fraction = (parts[1] || '').replace(/0+$/, '');
            return parts[0].replace(/^0+(?=\d)/, '') + (fraction ? '.' + fraction : '');
          }
          expected = expected.map(decimal).sort();
          actual = actual.map(decimal).sort();
          if (expected.indexOf(null) !== -1 || actual.indexOf(null) !== -1) return false;
          if (!expected.length) {
            // The native price renderer fills untouched bounds with min/max.
            // Only declared numeric range endpoints are neutral defaults.
            var controls = Array.prototype.filter.call(root.querySelectorAll('input[name]'), function (control) { return control.name === key; });
            var bound = /\.gte$/.test(key) ? 'min' : 'max';
            if (controls.length && controls.every(function (control) {
              var range = control.closest('price-range');
              var endpoint = control.getAttribute(bound);
              return control.type === 'number' && range && endpoint != null &&
                decimal(endpoint) === decimal(range.getAttribute('data-' + bound) || '') &&
                decimal(control.value) === decimal(endpoint);
            })) actual = [];
          }
        }
        return (!expected.length || names.indexOf(key) !== -1) && JSON.stringify(actual) === JSON.stringify(expected);
      })) return false;
    }
    var valid = true;
    root.querySelectorAll('input[name="q"], input[name="type"]').forEach(function (control) {
      if (control.name === 'q' && normQuery(control.value) !== normQuery(state.q)) valid = false;
      if (control.name === 'type' && control.value !== 'product') valid = false;
    });
    root.querySelectorAll('form').forEach(function (form) {
      if (form.querySelectorAll('input[name="q"]').length > 1 || form.querySelectorAll('input[name="type"]').length > 1) valid = false;
    });
    if (state.sort) {
      var sorts = selectedResultValues(root, 'sort_by').concat(selectedResultValues(root, 'sortBy'));
      var aliases = { price_asc: 'price-ascending', price_desc: 'price-descending', title_asc: 'title-ascending', title_desc: 'title-descending' };
      if ((native && !sorts.length) || sorts.some(function (value) { return (native ? value : aliases[value] || value) !== state.sort; })) valid = false;
    }
    var pages = selectedResultValues(root, 'page');
    root.querySelectorAll('.pagination-holder [aria-current="page"]').forEach(function (node) { pages.push(node.textContent.trim()); });
    if (pages.some(function (value) { return !/^[1-9]\d*$/.test(value) || Number(value) !== (state.page || 1); })) valid = false;
    ['options[prefix]', 'options[unavailable_products]'].forEach(function (name) {
      var expected = name === 'options[prefix]' ? state.optionsPrefix : state.optionsUnavailable;
      if (expected && selectedResultValues(root, name).some(function (value) { return value !== expected; })) valid = false;
    });
    return valid;
  }

  function commitNodes(live, incoming) {
    var current = document.querySelector('filter-component.plp-shell');
    var next = incoming && incoming.querySelector('filter-component.plp-shell');
    if (!current || !next) return { ok: false, reason: 'invalid_payload' };
    // The whole result owner is validated before a single DOM mutation.
    // Forms, facets, chips, count, sort and pages travel with its cards.
    if (!next.querySelector('.search-results-body, .collection-results-body') ||
        readTotal(next) == null || !next.querySelector('.search-results-footer, .collection-results-footer')) {
      return { ok: false, reason: 'invalid_payload' };
    }
    var focus = captureFocus();
    var replacement = sanitizeResultMarkup(next.cloneNode(true));
    current.replaceWith(replacement);
    restoreFocus(focus);
    window.dispatchEvent(new Event('sfs:results-updated'));
    return { ok: true };
  }

  function writeHistory(source, state, url, mode) {
    if (typeof window === 'undefined' || !window.history) return;
    var payload = Object.assign({}, window.history.state || {}, { sfsFallback: { source: source, key: sessionKey(state), request: requestKey(state), page: state.page || 1 } });
    renderedSearchUrl = url || window.location.href;
    renderedSearchState = state;
    var href = url || window.location.href;
    if (source === 'engine') {
      var engineHref = new URL(href, originBase());
      engineHref.searchParams.delete('sfs_native');
      href = engineHref.pathname + engineHref.search + engineHref.hash;
      renderedSearchUrl = href;
    }
    if (mode === 'push' && window.history.pushState) window.history.pushState(payload, '', href);
    else if (window.history.replaceState) window.history.replaceState(payload, '', href);
    refreshFilterAvailability();
  }

  function finishNativeFailure(state) {
    record('native_failure', { surface: 'search' });
    releaseFirstPaint();
    if (renderedSearchUrl && window.history) window.history.replaceState(window.history.state, '', renderedSearchUrl);
    setStatus(NATIVE_FAIL_COPY);
    var node = statusNode();
    if (node && node.parentNode && typeof document !== 'undefined' && document.createElement &&
        !(node.parentNode.querySelector && node.parentNode.querySelector('[data-sfs-browse-link]'))) {
      var link = document.createElement('a');
      link.href = browseHref();
      link.setAttribute('data-sfs-browse-link', '');
      link.textContent = 'Browse products';
      node.parentNode.insertBefore(link, node.nextSibling);
    }
    markNativeMode(!renderedSearchState || readSource(renderedSearchState) !== 'engine');
    return { ok: false, source: 'native', reason: 'native_failure', state: state };
  }

  function showNative(state, options) {
    options = options || {};
    var token = options.token || beginRequest('search');
    var plan = searchPlan(state);
    if (!plan.exactForNative) {
      explainHold(state);
      return Promise.resolve({ ok: false, held: true, unsupported: true });
    }
    if (!nativeFiltersSupported(state)) {
      explainHold(state);
      return Promise.resolve({ ok: false, held: true, unsupported: true });
    }
    if (state.poles && state.poles.length) {
      if (nativeFacetNames.indexOf('filter.p.m.breakers.poles') === -1) {
        explainHold(state);
        return Promise.resolve({ ok: false, held: true, unsupported: true });
      }
    }
    var previous = options.previousSource || readSource(state);
    var next = {
      q: state.q,
      type: state.type,
      collection: state.collection,
      sort: state.sort,
      page: pageForSourceChange(previous, 'native', state.page),
      poles: (state.poles || []).slice(),
      availability: (state.availability || []).slice(),
      extraFilters: (state.extraFilters || []).slice(),
      hardUnsupported: [],
      optionsPrefix: state.optionsPrefix,
      optionsUnavailable: state.optionsUnavailable,
      sfsNative: true
    };
    if (!isCurrent('search', token)) return Promise.resolve({ stale: true });
    if (restoreBaseline(next) && requestKey(next) === (baseline && baseline.key)) {
      releaseFirstPaint();
      document.documentElement.removeAttribute('data-sfs-hold-results');
      document.documentElement.removeAttribute('data-sfs-filter-blocked');
      syncBlockedDrawerButton();
      rememberSource('native', next);
      setBusy(false);
      setStatus('');
      writeHistory('native', next, nativeDocumentUrl(next).url, options.historyMode || 'replace');
      if (options.analyticsIntent && window.SBAnalytics) window.SBAnalytics.filterCommit(options.analyticsIntent, resultsRoot());
      return Promise.resolve({ ok: true, source: 'native', reusedBaseline: true });
    }
    var section = nativeSearchSectionUrl(next);
    if (!section.sectionId) return Promise.resolve(finishNativeFailure(next));
    setBusy(true);
    return fetchBudget(section.url, timeoutMs()).then(function (html) {
      if (!isCurrent('search', token)) return { stale: true };
      var doc = parseHtml(html);
      if (!searchResponseMatches(doc, next, true, section.sectionId)) return finishNativeFailure(next);
      var nativeVerdict = classifyEngineDocument(doc, next);
      var root = resultsRoot();
      if (nativeVerdict.reason === 'invalid_payload' || !root) return finishNativeFailure(next);
      var committed = commitNodes(root, doc);
      if (!committed.ok) return finishNativeFailure(next);
      if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.removeAttribute('data-sfs-hold-results');
        document.documentElement.removeAttribute('data-sfs-filter-blocked');
        syncBlockedDrawerButton();
      }
      releaseFirstPaint();
      rememberSource('native', next);
      setStatus(nativeVerdict.reason === 'engine_zero' || nativeVerdict.cards === 0 ? '' : '');
      if ((nativeVerdict.cards || 0) === 0 && (nativeVerdict.total === 0 || nativeVerdict.reason === 'engine_zero')) {
        setStatus('No results found.');
      }
      writeHistory('native', next, section.shopper, options.historyMode || 'replace');
      if (options.analyticsIntent && window.SBAnalytics) window.SBAnalytics.filterCommit(options.analyticsIntent, resultsRoot());
      return { ok: true, source: 'native', empty: (nativeVerdict.cards || 0) === 0 && !(nativeVerdict.total > 0) };
    }).catch(function (err) {
      if (!isCurrent('search', token) || classifyEngineError(err) === 'aborted') return { stale: true };
      return finishNativeFailure(next);
    }).finally(function () {
      if (isCurrent('search', token)) setBusy(false);
    });
  }

  function fallbackSearchUrl(href) {
    var url = new URL(nativeDocumentUrl(href).url, originBase());
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set('options[unavailable_products]', 'last');
    url.searchParams.set('sfs_native', '1');
    url.searchParams.delete('page');
    return url.pathname + url.search;
  }

  function proxyPageHasStableResultStructure(root) {
    return !!(
      root &&
      root.querySelector('filter-component.plp-shell .collection-main') &&
      (root.querySelector('.sfs-results-head .section-heading') ||
        root.querySelector('.sfs-results-head--normalized .section-heading') ||
        root.querySelector('.section-heading-wrapper .section-heading')) &&
      root.querySelector('.product-card, .sfs-empty')
    );
  }

  function revealProxyFallback() {
    document.documentElement.setAttribute('data-sfs-fallback-done', '');
  }

  function prepareProxyNative(doc, state, sectionId, href) {
    var section = doc.querySelector('#shopify-section-' + sectionId);
    var root = section && section.querySelector('filter-component.plp-shell');
    var form = root && root.querySelector('#mainForm' + sectionId);
    // This unfiltered probe also accepts native sections without facet metadata.
    // Constrained pages never enter this path. Validate identity before mutation.
    if (!root || root.getAttribute('data-section-id') !== sectionId || !form ||
        form.querySelectorAll('input[name="q"]').length !== 1 ||
        form.querySelectorAll('input[name="type"]').length !== 1 ||
        !searchResponseMatches(doc, state, false) ||
        (state.sort && selectedResultValues(root, 'sort_by').indexOf(state.sort) === -1)) return null;
    var total = readTotal(root);
    var cards = countRenderable(root);
    if (!cards || total == null || total < cards ||
        cards !== root.querySelectorAll('.product-card').length) return null;
    var prepared = sanitizeResultMarkup(section.cloneNode(true));
    prepared.querySelectorAll('.sidebar-section, .filter-btn, [data-sfs-results-status]').forEach(function (node) { node.remove(); });
    prepared.querySelectorAll('.pagination a[href]').forEach(function (link) {
      var page = new URL(link.getAttribute('href'), originBase()).searchParams.get('page');
      var next = new URL(fallbackSearchUrl(href), originBase());
      next.searchParams.set('page', String(pageNumber(page)));
      link.setAttribute('href', presentHref(next.pathname + next.search));
    });
    return { section: prepared, total: total };
  }

  function insertProxyNative(prepared, state) {
    var live = document.querySelector('#shopify-section-proxy-search');
    if (!live) return false;
    live.setAttribute('data-sfs-native-in-place', '');
    live.querySelectorAll('.search-assist, .search-assist__row, #search-assist-placeholder').forEach(function (node) { node.remove(); });
    var grid = live.querySelector('.list-products');
    if (grid) grid.style.display = '';
    var result = live.querySelector('.collection-results-wrapper');
    var heading = live.querySelector('h1.section-heading');
    if (grid && result && heading) {
      var cards = Array.prototype.map.call(prepared.section.querySelectorAll('.product-card'), function (card) {
        return document.importNode(card, true);
      });
      var pagination = prepared.section.querySelector('.pagination-holder');
      grid.replaceChildren.apply(grid, cards);
      var shell = grid.closest('filter-component.plp-shell');
      if (shell) shell.classList.remove('sfs-zero-catalog-active');
      live.querySelectorAll('.sfs-empty, .facet-guide, .sfs-zero-catalog, .sfs-zero-quote, .sfs-rfq, .sfs-closest-notice, .sfs-closest-matches').forEach(function (node) { node.remove(); });
      // Catalog recovery mounts outside the proxy section (or its main owner).
      var catalog = document.getElementById('SfsHomeCatalogMount');
      if (catalog) catalog.remove();
      var body = grid.closest('.collection-results-body');
      if (body) body.replaceChildren(grid);
      result.querySelectorAll('.collection-results-header .plp-toolbar-count').forEach(function (node) {
        node.textContent = prepared.total.toLocaleString('en-US') + (prepared.total === 1 ? ' result' : ' results');
        node.setAttribute('data-search-results-total', String(prepared.total));
      });
      var query = heading.querySelector('.search-query-display');
      if (query) query.textContent = '“' + state.q + '”';
      var nativeShell = prepared.section.querySelector('filter-component.plp-shell');
      if (shell && nativeShell) {
        try { nativeFacetNames = JSON.parse(nativeShell.getAttribute('data-sfs-native-facets') || '[]'); } catch (e) { nativeFacetNames = []; }
        nativeSortValues = Array.prototype.map.call(nativeShell.querySelectorAll('input[name="sort_by"], input[name="sortBy"], select[name="sort_by"] option'), function (option) { return option.value; });
        ['data-sfs-native-facets', 'data-sfs-native-poles'].forEach(function (key) {
          shell.setAttribute(key, nativeShell.getAttribute(key) || '');
        });
      }
      result.classList.remove('flex-w-md-4/5');
      var footer = result.querySelector('.collection-results-footer');
      if (!footer) {
        footer = document.createElement('div');
        footer.className = 'collection-results-footer';
        result.appendChild(footer);
      }
      footer.replaceChildren();
      if (pagination) footer.appendChild(document.importNode(pagination, true));
    } else {
      live.replaceChildren.apply(live, importChildren(prepared.section));
    }
    live.querySelectorAll('h1.section-heading .sfs-result-count').forEach(function (node) { node.remove(); });
    var status = live.querySelector('[aria-live="polite"]');
    var newStatus = !status;
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('role', 'status');
      status.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
      live.appendChild(status);
    }
    var announcement = 'Showing ' + prepared.total.toLocaleString('en-US') + (prepared.total === 1 ? ' result.' : ' results.');
    if (newStatus) {
      window.requestAnimationFrame(function () { status.textContent = announcement; });
    } else {
      status.textContent = announcement;
    }
    revealProxyFallback();
    rememberSource('native', state);
    // Stop engine delegates from owning the inserted native controls.
    live.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('.pagination a[href]');
      if (link) event.stopImmediatePropagation();
    }, true);
    live.addEventListener('change', function (event) {
      var control = event.target;
      if (!control.matches('select[name="sort_by"], input[name="sort_by"], input[name="sortBy"]')) return;
      var aliases = { price_asc: 'price-ascending', price_desc: 'price-descending', title_asc: 'title-ascending', title_desc: 'title-descending' };
      var sort = aliases[control.value] || control.value || 'relevance';
      if (!SHOPIFY_SORTS[sort]) return;
      var next = new URL(fallbackSearchUrl(window.location.href), originBase());
      next.searchParams.set('sort_by', sort);
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(presentHref(next.pathname + next.search));
    }, true);
    return true;
  }

  function enhanceSearchDocument() {
    if (typeof document === 'undefined') return Promise.resolve({ skipped: true });
    if (!enabled() || !/^\/a\/search\/?$/.test(window.location.pathname)) {
      revealProxyFallback();
      return Promise.resolve({ skipped: true });
    }
    if (countRenderable(document) > 0) {
      rememberSource('engine', readState(window.location.href));
      revealProxyFallback();
      return Promise.resolve({ source: 'engine' });
    }
    var state = readState(window.location.href);
    var facetLoad = loadFacetDocument(state);
    if (facetLoad) return facetLoad;
    if (!state.q || (state.type && state.type !== 'product') || hasNarrowing(state) ||
        (state.engineFilters && state.engineFilters.length)) {
      revealProxyFallback();
      return Promise.resolve({ skipped: true });
    }
    var empty = document.querySelector('.sfs-empty');
    var heading = document.querySelector('h1.section-heading');
    var section = document.querySelector('#shopify-section-proxy-search');
    var busy = !empty && ((heading && /Search is busy/i.test((section || heading).textContent)) ||
      !proxyPageHasStableResultStructure(section || document));
    if (busy) noteFailure('http_error', { surface: 'search' });
    else if (empty) record('engine_zero', { surface: 'search' });
    else {
      revealProxyFallback();
      return Promise.resolve({ skipped: true });
    }
    var token = beginRequest('search');
    var href = window.location.href;
    var sectionRequest = nativeSearchSectionUrl(state);
    return fetchBudget(sectionRequest.url, timeoutMs()).then(function (html) {
      if (!isCurrent('search', token) || leavingPage || window.location.href !== href) return { stale: true };
      var prepared = prepareProxyNative(parseHtml(html), state, sectionRequest.sectionId, href);
      if (prepared && insertProxyNative(prepared, state)) return { source: 'native', reason: busy ? 'http_error' : 'engine_zero' };
      return { source: 'engine' };
    }).catch(function () { return { source: 'engine' }; }).finally(function () {
      revealProxyFallback();
    });
  }

  function isResultsControl(link) {
    if (!link || !link.closest) return false;
    if (link.closest('.product-card, .card-wide-link, .sfs-tile, collection-search-filters, .predictive_search-button')) return false;
    if (!link.closest('filter-component.plp-shell')) return false;
    return !!link.closest('.pagination, .pagination-holder, .search-results-footer, .sort-section, .filter-active, search-active-filters, .collection-active-filters, .sidebar-section, [data-sfs-query-filters]');
  }

  function handleResultsLink(href, historyMode, analyticsIntent, options) {
    if (!enabled()) return Promise.resolve({ skipped: true });
    var state = readState(href);
    var current = readState(window.location.href);
    state.q = state.q || current.q;
    state.optionsPrefix = state.optionsPrefix || current.optionsPrefix;
    state.optionsUnavailable = state.optionsUnavailable || current.optionsUnavailable;
    if (state.hardUnsupported.length || (!searchPlan(state).exactForEngine && !searchPlan(state).exactForNative)) {
      beginRequest('search');
      explainHold(state);
      return Promise.resolve({ held: true, unsupported: true });
    }
    var source = readSource(state);
    if ((!(options && options.engineFirst) && (source === 'native' || shouldSkipEngine(state, true))) || !searchPlan(state).exactForEngine) {
      return showNative(state, { historyMode: historyMode || 'push', continuation: true, analyticsIntent: analyticsIntent });
    }
    var token = beginRequest('search');
    var engineUrl = engineSearchUrl(state);
    setBusy(true);
    function recoverNative() {
      if (options && options.engineFirst) rememberSource('native', state);
      return showNative(state, { token: token, historyMode: historyMode || 'push', previousSource: 'engine', analyticsIntent: analyticsIntent });
    }
    return fetchBudget(engineUrl, timeoutMs()).then(function (html) {
      if (!isCurrent('search', token)) return { stale: true };
      var doc = parseHtml(html);
      if (!searchResponseMatches(doc, state, false)) throw Object.assign(new Error('mismatched search response'), { sfsReason: 'invalid_payload' });
      var verdict = classifyEngineDocument(doc, state);
      if (verdict.reason === 'engine_zero') {
        record('engine_zero', { surface: 'search' });
        return recoverNative();
      }
      if (verdict.action !== 'engine') {
        noteFailure(verdict.reason || 'invalid_payload', { surface: 'search' });
        return recoverNative();
      }
      var committed = commitNodes(resultsRoot(), doc);
      if (!committed.ok) {
        noteFailure('invalid_payload', { surface: 'search' });
        return recoverNative();
      }
      releaseFirstPaint();
      document.documentElement.removeAttribute('data-sfs-hold-results');
      document.documentElement.removeAttribute('data-sfs-filter-blocked');
      syncBlockedDrawerButton();
      rememberSource('engine', state);
      var target = new URL(nativeDocumentUrl(state).url, originBase());
      if (/^\/a\/search\/?$/.test(window.location.pathname)) {
        target.pathname = '/a/search';
        target.searchParams.delete('sort_by');
        var engineSort = new URL(engineUrl, originBase()).searchParams.get('sort');
        if (engineSort) target.searchParams.set('sort', engineSort);
        target.searchParams.set('sfs_filters', '1');
        var brandLabel = new URL(href, originBase()).searchParams.get('sb_brand_label');
        if (brandLabel) target.searchParams.set('sb_brand_label', brandLabel);
      }
      writeHistory('engine', state, target.pathname + target.search, historyMode || 'push');
      setStatus('');
      if (window.SBAnalytics && window.SBAnalytics.filterCommit) {
        if (analyticsIntent) window.SBAnalytics.filterCommit(analyticsIntent, resultsRoot());
      }
      return { ok: true, source: 'engine' };
    }).catch(function (err) {
      if (!isCurrent('search', token) || classifyEngineError(err) === 'aborted') return { stale: true };
      noteFailure(classifyEngineError(err), { surface: 'search' });
      return recoverNative();
    }).finally(function () { if (isCurrent('search', token)) setBusy(false); });
  }

  function installResultsGuard() {
    if (guardInstalled || typeof document === 'undefined' || !document.addEventListener) return;
    guardInstalled = true;
    window.addEventListener('pagehide', function () { leavingPage = true; });
    window.addEventListener('beforeunload', function () { leavingPage = true; });
    window.addEventListener('pageshow', function () {
      if (documentSource) {
        storageSet(documentSource.key, documentSource.value);
        markNativeMode(documentSource.source === 'native');
      }
      leavingPage = false;
      window.__sfsSearchCommitted = false;
    });
    document.addEventListener('submit', function (event) {
      if (!enabled()) return;
      var form = event.target;
      if (!form || !form.matches || !form.matches('form.form-search[action="/a/search"], form.sb-home-hero__search[action="/a/search"], form.page-recovery__search[action="/a/search"], form.search-retry-form[action="/a/search"]') ||
          (!form.matches('form.search-retry-form') && form.closest && form.closest('filter-component.plp-shell, collection-search-filters'))) return;
      var next = new URL('/a/search', originBase());
      new FormData(form).forEach(function (value, key) { next.searchParams.append(key, value); });
      if (pageInCooldown() && !hasNarrowing(readState(next.href)) && !(readState(next.href).engineFilters || []).length) {
        event.preventDefault();
        window.location.assign(fallbackSearchUrl(next.href));
      }
    }, true);
    document.addEventListener('click', function (event) {
      if (!enabled() || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      var link = event.target && event.target.closest && event.target.closest('a[href]');
      if (!link || (link.hasAttribute && link.hasAttribute('data-sfs-retry-filters'))) return;
      var url = new URL(link.href, originBase());
      if (url.origin !== window.location.origin || !/^\/a\/search\/?$/.test(url.pathname)) return;
      if (link.closest('filter-component.plp-shell, collection-search-filters') && !link.closest('.predictive_search-button, .js-search-result')) return;
      if (pageInCooldown() && !hasNarrowing(readState(url.href)) && !(readState(url.href).engineFilters || []).length) {
        event.preventDefault();
        window.location.assign(fallbackSearchUrl(url.href));
      }
    }, true);
    function nativeCollectionNavigation(event) {
      if (!enabled()) return false;
      var control = event.target;
      var host = control && control.closest && control.closest('collection-search-filters');
      if (!host || !host._sfsNativeCommitted) return false;
      var rail = control.closest('[data-sfs-native-sidebar-live]');
      if (!rail) return false;
      var next = new URL(window.location.href);
      if (event.type === 'click') {
        var link = control.closest('a[href]');
        if (!link) return false;
        var safe = presentHref(link.getAttribute('href'));
        if (!safe) return false;
        next = new URL(safe, originBase());
      } else if (event.type === 'change') {
        if (!control.name || control.name.indexOf('filter.') !== 0) return false;
        next.searchParams.delete(control.name);
        rail.querySelectorAll('input[name]').forEach(function (input) {
          if (input.name === control.name && (input.type !== 'checkbox' || input.checked)) next.searchParams.append(input.name, input.value);
        });
      } else return false;
      if (next.origin !== window.location.origin || next.pathname.replace(/\/$/, '') !== '/collections/' + host.collectionHandle) return false;
      next.searchParams.set('sfs_native', '1');
      copyPreview(next, new URL(originBase()));
      next.searchParams.delete('page');
      event.preventDefault();
      event.stopImmediatePropagation();
      if (window.SBJourney) {
        var clearControl = control.closest('.jsFilterRemove, .jsFilterReset');
        if (clearControl) window.SBJourney.filterClear(clearControl);
        window.SBJourney.filterNavigate(control.closest('a[href]') || control, next.href,
          event.type === 'change' ? (control.checked ? 'add' : 'remove') : 'remove');
      }
      window.location.assign(next.pathname + next.search);
      return true;
    }
    document.addEventListener('click', nativeCollectionNavigation, true);
    document.addEventListener('change', nativeCollectionNavigation, true);
    document.addEventListener('click', function (event) {
      if (!enabled() || !event || event.defaultPrevented || !/^\/(?:a\/)?search\/?$/.test(window.location.pathname)) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      var target = event.target;
      var reset = target && target.closest && target.closest('.jsFilterReset');
      if (reset && reset.closest('filter-component.plp-shell') && /^\/search\/?$/.test(window.location.pathname)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var clear = readState(window.location.href);
        if (window.SBJourney) window.SBJourney.filterClear(reset);
        handleResultsLink(clearFilterHref(clear), 'push');
        return;
      }
      var link = target && target.closest ? target.closest('a[href]') : null;
      if (!isResultsControl(link) || (link.hasAttribute && link.hasAttribute('data-sfs-retry-filters'))) return;
      var railLink = link.matches('[data-sfs-query-filter-link], [data-sfs-filter-link]');
      if (!/^\/search\/?$/.test(window.location.pathname) && !railLink) return;
      event.preventDefault();
      if (/^\/search\/?$/.test(window.location.pathname)) event.stopImmediatePropagation();
      if (window.SBJourney && link.matches('.jsFilterRemove, [data-sfs-remove-filter]')) window.SBJourney.filterClear(link);
      var intent = !link.closest('.pagination-holder, .sort-section') && window.SBAnalytics ? window.SBAnalytics.filterIntent(link) : null;
      var request = handleResultsLink(link.getAttribute('href') || link.href, 'push', intent);
      var row = railLink && link.closest('[data-sfs-filter-item], [data-sfs-query-option-item], .filter-item, .filter-section-list-item, li');
      var checkbox = row && row.querySelector('input[type="checkbox"]');
      if (checkbox) {
        var checked = checkbox.checked;
        checkbox.checked = !checked;
        var restore = function () {
          if (restoreFilterRow !== restore) return;
          checkbox.checked = checked;
          restoreFilterRow = null;
        };
        restoreFilterRow = restore;
        request.finally(restore);
      }
    }, true);
    document.addEventListener('change', function (event) {
      if (!enabled() || window.location.pathname !== '/search') return;
      var control = event.target;
      if (!control || !control.matches || !control.matches('input[name="sort_by"], input[name="sortBy"], select[name="sort_by"], input[name^="filter."][auto-submit]')) return;
      if (!control.closest('filter-component.plp-shell')) return;
      event.stopImmediatePropagation();
      var next = new URL(window.location.href);
      if (control.name.indexOf('filter.') === 0) {
        next.searchParams.delete(control.name);
        control.closest('filter-component').querySelectorAll('input[name]').forEach(function (input) {
          if (input.name === control.name && input.checked) next.searchParams.append(input.name, input.value);
        });
      } else {
        next.searchParams.set('sort_by', control.value);
        next.searchParams.delete('sort');
      }
      next.searchParams.delete('page');
      var intent = control.name.indexOf('filter.') === 0 && window.SBAnalytics ? window.SBAnalytics.filterIntent(control) : null;
      handleResultsLink(next.href, 'push', intent);
    }, true);
    document.addEventListener('submit', function (event) {
      if (!enabled() || window.location.pathname !== '/search') return;
      var form = event.target;
      if (!form || !form.closest || !form.closest('filter-component.plp-shell')) return;
      if (!/^mainForm/.test(form.id || '')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var next = new URL('/search', window.location.href);
      copyPreview(next, new URL(window.location.href));
      new FormData(form).forEach(function (value, key) { next.searchParams.append(key, value); });
      next.searchParams.delete('page');
      handleResultsLink(next.href, 'push');
    }, true);
  }

  function recoverResultsNavigation(href) {
    var built = nativeDocumentUrl(href || (typeof window !== 'undefined' ? window.location.href : '/search'));
    var url = new URL(built.url, originBase());
    url.searchParams.set('sfs_native', '1');
    var state = built.state;
    if (readSource(state) === 'engine') url.searchParams.delete('page');
    var next = url.pathname + url.search;
    if (typeof window !== 'undefined' && window.location && typeof window.location.replace === 'function') {
      window.location.replace(next);
    }
    return next;
  }

  function copyCollectionState(state, page) {
    var filters = {};
    var source = (state && state.filters) || {};
    Object.keys(source).forEach(function (key) {
      filters[key] = (source[key] || []).slice();
    });
    return { filters: filters, sort: state && state.sort || 'best-selling', page: page || (state && state.page) || 1 };
  }

  function showHostNote(host, message) {
    if (!host || typeof host.querySelector !== 'function') return;
    var note = host.querySelector('[data-sfs-collection-fallback-note]');
    if (!note && message && typeof document !== 'undefined' && document.createElement) {
      note = document.createElement('p');
      note.setAttribute('data-sfs-collection-fallback-note', '');
      note.setAttribute('role', 'status');
      note.className = 'sfs-fallback-note';
      if (host.insertBefore) host.insertBefore(note, host.firstChild);
    }
    if (!note) return;
    note.hidden = !message;
    note.textContent = message || '';
  }

  function swapCollectionSection(host, doc, nextState) {
    var grid = host.gridId && host.querySelector('#' + host.gridId);
    var pagination = host.querySelector('.collection-results-footer .pagination-holder');
    var count = host.querySelector('.collection-count');
    var nextGrid = doc.querySelector('#' + host.gridId);
    var nextPage = doc.querySelector('.collection-results-footer .pagination-holder');
    var nextCount = doc.querySelector('.collection-count');
    var template = doc.querySelector('template[data-sfs-native-sidebar]');
    var nextRail = template && template.content.querySelector('.sidebar-section');
    var oldRail = host.querySelector('.sidebar-section');
    if (!grid || !pagination || !count || !nextGrid || !nextPage || !nextCount || (oldRail && !nextRail)) return false;
    var preparedGrid = sanitizeResultMarkup(nextGrid.cloneNode(true));
    var nextTotal = parseTotal(nextCount.textContent);
    var cards = countRenderable(preparedGrid);
    if (nextTotal == null || (nextTotal > 0 && nextState.page === 1 && !cards) ||
        (!cards && preparedGrid.querySelector('.product-card')) || (cards > 0 && nextTotal === 0)) return false;
    if (nextTotal === 0 && !preparedGrid.querySelector('.no-result-text, .search-no-result')) return false;
    var focus = captureFocus();
    var preparedRail = nextRail && sanitizeResultMarkup(nextRail.cloneNode(true));
    var preparedPage = sanitizeResultMarkup(nextPage.cloneNode(true));
    if (preparedRail) {
      preparedRail.setAttribute('data-sfs-native-sidebar-live', '');
      preparedRail.querySelectorAll('a[href]').forEach(function (link) {
        var safe = presentHref(link.getAttribute('href'));
        if (safe) link.setAttribute('href', safe);
        else link.removeAttribute('href');
      });
    }
    grid.replaceChildren.apply(grid, importChildren(preparedGrid));
    pagination.replaceWith(preparedPage);
    count.textContent = (nextCount.textContent || '').trim();
    if (oldRail && preparedRail) oldRail.replaceWith(preparedRail);
    // The native rail carries native chips. Clear custom engine chips.
    if (window.SFS_ACTIVE_FILTERS && typeof window.SFS_ACTIVE_FILTERS.render === 'function') window.SFS_ACTIVE_FILTERS.render({}, null);
    host.querySelectorAll('[data-sfs-active-controls]').forEach(function (strip) { strip.hidden = true; });
    restoreFocus(focus);
    return true;
  }

  function serveCollectionWithoutEngine(host, state, options) {
    options = options || {};
    var plan = collectionPlan(state);
    var session = collectionSession(host, state);
    function hold(message) {
      host._sfsStatusOverride = message;
      showHostNote(host, message);
      if (host.renderedState) host.currentState = copyCollectionState(host.renderedState);
      if (host.currentState) host.desiredState = copyCollectionState(host.currentState);
      if (host.renderedUrl && window.history) window.history.replaceState(window.history.state, '', host.renderedUrl);
      if (typeof host.syncControls === 'function') host.syncControls(host.currentState);
      if (typeof host.setBusy === 'function') host.setBusy(false);
    }
    var currentNative = readState(originBase());
    if (currentNative.q || currentNative.hardUnsupported.length ||
        !nativeConstraintSupported(Object.assign({}, currentNative, { poles: plan.poles }), host, plan)) {
      hold(UNSUPPORTED_COPY);
      if (typeof host.announce === 'function') host.announce(UNSUPPORTED_COPY);
      return Promise.resolve({ skipDefault: true, unsupported: true });
    }
    var previous = options.previousSource || readSource(session);
    var next = copyCollectionState(state, pageForSourceChange(previous, 'native', state.page));
    session.page = next.page;
    var built;
    try { built = nativeCollectionUrl(host, next, 'section'); } catch (e) {
      record('native_failure', { surface: 'collection' });
      hold(NATIVE_FAIL_COPY);
      return Promise.resolve({ skipDefault: true, reason: 'native_failure' });
    }
    if (!built.sectionId) {
      record('native_failure', { surface: 'collection' });
      hold(NATIVE_FAIL_COPY);
      return Promise.resolve({ skipDefault: true, reason: 'native_failure' });
    }
    var token = beginRequest('collection');
    if (typeof host.setBusy === 'function') host.setBusy(true);
    return fetchBudget(built.url, timeoutMs(), null, 'collection').then(function (html) {
      if (!isCurrent('collection', token)) return { stale: true, skipDefault: true };
      if (host.desiredState && JSON.stringify(copyCollectionState(host.desiredState)) !== JSON.stringify(copyCollectionState(state)) &&
          JSON.stringify(copyCollectionState(host.desiredState)) !== JSON.stringify(next)) {
        return { stale: true, skipDefault: true };
      }
      // Extract the inert native rail before the sanitizer drops templates.
      // swapCollectionSection sanitizes every node that reaches the live page.
      var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
      if (!swapCollectionSection(host, doc, next)) {
        record('native_failure', { surface: 'collection' });
        hold(NATIVE_FAIL_COPY);
        return { skipDefault: true, reason: 'native_failure' };
      }
      host.currentState = next;
      host.renderedState = copyCollectionState(next);
      host.desiredState = copyCollectionState(next);
      host.renderedUrl = built.shopper;
      writeHistory('native', session, built.shopper, options.historyMode || 'replace');
      host._sfsNativeCommitted = true;
      host._sfsStatusOverride = '';
      if (typeof host.syncControls === 'function') host.syncControls(next);
      if (typeof host.announce === 'function') host.announce((host.querySelector('.collection-count') || {}).textContent || host.dataset.resultsUpdatedMessage || '');
      if (typeof host.restoreFocus === 'function') host.restoreFocus(options.focusLabel || '');
      if (options.scrollToGrid && typeof host.scrollToGrid === 'function') host.scrollToGrid();
      if (options.analyticsIntent && window.SBAnalytics && typeof window.SBAnalytics.filterCommit === 'function') {
        window.SBAnalytics.filterCommit(options.analyticsIntent, host);
      }
      rememberSource('native', session);
      showHostNote(host, '');
      return { skipDefault: true, committed: true };
    }).catch(function (err) {
      if (!isCurrent('collection', token) || classifyEngineError(err) === 'aborted') {
        return { stale: true, skipDefault: true };
      }
      record('native_failure', { surface: 'collection' });
      hold(NATIVE_FAIL_COPY);
      return { skipDefault: true, reason: 'native_failure' };
    }).finally(function () {
      if (isCurrent('collection', token) && typeof host.setBusy === 'function') host.setBusy(false);
    });
  }

  function initializeNativeCollection(host) {
    var state = host.currentState;
    var session = collectionSession(host, state);
    if (!enabled()) return false;
    var current = readState(originBase());
    var nativeMode = current.sfsNative || readSource(session) === 'native';
    var names;
    try { names = JSON.parse(host.getAttribute('data-sfs-native-facets') || '[]'); } catch (e) { names = []; }
    var missingNative = current.extraFilters.some(function (pair) { return names.indexOf(pair.split('=')[0]) === -1; }) ||
      (current.availability.length && names.indexOf('filter.v.availability') === -1);
    // Shopify collection q is not a text search. Never show that broad grid
    // as if it satisfied a collection query or an unknown native constraint.
    if (current.q || current.hardUnsupported.length || (nativeMode && missingNative)) {
      showHostNote(host, UNSUPPORTED_COPY);
      var wrapper = host.querySelector('.collection-results-wrapper');
      if (wrapper) wrapper.hidden = true;
      var note = host.querySelector('[data-sfs-collection-fallback-note]');
      var clear = document.createElement('a');
      var url = new URL('/collections/' + host.collectionHandle, originBase());
      copyPreview(url, new URL(originBase()));
      clear.href = url.pathname + url.search;
      clear.textContent = 'Clear filters and retry';
      note.appendChild(document.createTextNode(' '));
      note.appendChild(clear);
      return true;
    }
    if (!nativeMode) return false;
    var plan = collectionPlan(state);
    if (!plan.exactForNative || !swapCollectionSection(host, document, state)) {
      showHostNote(host, UNSUPPORTED_COPY);
      return true;
    }
    host._sfsNativeCommitted = true;
    rememberSource('native', session);
    return true;
  }

  function recoverCollectionFailure(host, state, options, reason) {
    if (reason && reason !== 'aborted' && reason !== 'engine_zero' && reason !== 'skip') {
      noteFailure(reason, { surface: 'collection' });
    }
    return serveCollectionWithoutEngine(host, state, Object.assign({}, options, { previousSource: 'engine' }));
  }

  function nativeFiltersSupported(state) {
    if (state.sort && nativeSortValues.indexOf(state.sort) === -1) return false;
    return nativeConstraintSupported(state);
  }

  function releaseFirstPaint() {
    if (!document.documentElement) return;
    document.documentElement.setAttribute('data-sfs-fallback-done', '');
  }

  function loadFacetDocument(state) {
    if (!searchPlan(state).exactForEngine || !state.engineFilters.some(function (pair) {
      return pair.indexOf('facets=') === 0;
    })) return false;
    // Shopify cannot render these constraints, including saved /search links.
    // Try the engine before deciding that this document needs backup results.
    holdResults();
    setStatus('');
    return handleResultsLink(window.location.href, 'replace', null, { engineFirst: true });
  }

  function boot() {
    if (!enabled() || typeof document === 'undefined') return;
    watchFilterAvailability();
    installResultsGuard();
    var path = window.location && window.location.pathname;
    if (path === '/a/search' || path === '/a/search/') {
      enhanceSearchDocument();
      return;
    }
    if (path === '/search' || path === '/search/') {
      captureBaseline();
      var state = readState(window.location.href);
      if (!loadFacetDocument(state)) {
        rememberSource('native', state);
        releaseFirstPaint();
        if (state.hardUnsupported.length || document.documentElement.hasAttribute('data-sfs-hold-results')) explainHold(state);
        else setStatus('');
        if (state.sfsNative) markNativeMode(true);
      }
    }
    window.addEventListener('popstate', function () {
      if (!enabled()) return;
      var here = window.location.pathname;
      if (here !== '/search' && here !== '/search/') return;
      var state = readState(window.location.href);
      var stored = window.history && window.history.state && window.history.state.sfsFallback;
      if (stored && stored.source) rememberSource(stored.source, state);
      if (state.hardUnsupported.length) explainHold(state);
      else if (loadFacetDocument(state)) return;
      else if (stored && stored.source === 'engine') handleResultsLink(window.location.href, 'replace');
      else showNative(state, { continuation: true, historyMode: 'replace' });
    });
  }

  function resetForTests() {
    generations.search = 0;
    generations.collection = 0;
    generations.dropdown = 0;
    memory = {};
    diagnostics = [];
    baseline = null;
    nativeSectionId = '';
    nativeFacetNames = [];
    nativeSortValues = [];
    renderedSearchUrl = '';
    renderedSearchState = null;
    documentSource = null;
    guardInstalled = false;
    leavingPage = false;
    searchAbort = null;
    nowFn = function () { return Date.now(); };
    try {
      if (typeof sessionStorage !== 'undefined') {
        var keys = [];
        for (var i = 0; i < sessionStorage.length; i += 1) {
          var key = sessionStorage.key(i);
          if (key === COOL_KEY || key === PAGE_COOL_KEY || key === DIAG_KEY || key.indexOf(SOURCE_PREFIX) === 0) keys.push(key);
        }
        keys.forEach(function (key) { sessionStorage.removeItem(key); });
      }
    } catch (e) {}
  }

  var api = {
    enabled: enabled,
    refreshFilterAvailability: refreshFilterAvailability,
    nativeConstraintSupported: nativeConstraintSupported,
    nativeDocumentUrl: nativeDocumentUrl,
    presentHref: presentHref,
    nativePredictiveUrl: nativePredictiveUrl,
    engineSearchUrl: engineSearchUrl,
    nativeSearchSectionUrl: nativeSearchSectionUrl,
    nativeCollectionUrl: nativeCollectionUrl,
    readState: readState,
    searchPlan: searchPlan,
    collectionPlan: collectionPlan,
    requestKey: requestKey,
    sessionKey: sessionKey,
    classifySuggest: classifySuggest,
    fetchSuggest: fetchSuggest,
    classifyEngineDocument: classifyEngineDocument,
    classifyCollectionSource: classifyCollectionSource,
    inspectCollectionResponse: inspectCollectionResponse,
    classifyEngineError: classifyEngineError,
    record: record,
    noteFailure: noteFailure,
    inCooldown: inCooldown,
    pageInCooldown: pageInCooldown,
    clearCooldown: clearCooldown,
    rememberSource: rememberSource,
    readSource: readSource,
    clearSource: clearSource,
    pageForSourceChange: pageForSourceChange,
    shouldSkipEngine: shouldSkipEngine,
    shouldSkipCollectionEngine: shouldSkipCollectionEngine,
    blockOptionSearch: blockOptionSearch,
    beginRequest: beginRequest,
    isCurrent: isCurrent,
    lastDiagnostic: lastDiagnostic,
    enhanceSearchDocument: enhanceSearchDocument,
    handleResultsLink: handleResultsLink,
    showNative: showNative,
    recoverResultsNavigation: recoverResultsNavigation,
    serveCollectionWithoutEngine: serveCollectionWithoutEngine,
    recoverCollectionFailure: recoverCollectionFailure,
    initializeNativeCollection: initializeNativeCollection,
    captureBaseline: captureBaseline,
    explainHold: explainHold,
    installResultsGuard: installResultsGuard,
    boot: boot,
    resetForTests: resetForTests,
    fetchBudget: fetchBudget,
    nativeFiltersSupported: nativeFiltersSupported,
    releaseFirstPaint: releaseFirstPaint,
    setNowForTests: function (fn) { nowFn = fn || function () { return Date.now(); }; },
    unsupportedCopy: UNSUPPORTED_COPY,
    nativeFailureCopy: NATIVE_FAIL_COPY
  };

  if (typeof window !== 'undefined') window.SFSNativeFallback = api;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})();
